/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.3.0 (NJsonSchema v10.6.4.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
import axios from 'axios';
export class AdresseClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @param postcode (optional)
     * @return Success
     */
    searchAdresse(query, postcode, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Adresse/search?";
        if (query === undefined || query === null)
            throw new Error("The parameter 'query' must be defined and cannot be null.");
        else
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (postcode === null)
            throw new Error("The parameter 'postcode' cannot be null.");
        else if (postcode !== undefined)
            url_ += "postcode=" + encodeURIComponent("" + postcode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processSearchAdresse(_response);
        });
    }
    processSearchAdresse(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class ArtisteClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @return Success
     */
    getArtiste(artisteId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Artiste/{artisteId}";
        if (artisteId === undefined || artisteId === null)
            throw new Error("The parameter 'artisteId' must be defined.");
        url_ = url_.replace("{artisteId}", encodeURIComponent("" + artisteId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetArtiste(_response);
        });
    }
    processGetArtiste(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param search (optional)
     * @return Success
     */
    autocompleteArtistePrenom(search, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Artiste/autocomplete/prenom?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAutocompleteArtistePrenom(_response);
        });
    }
    processAutocompleteArtistePrenom(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param search (optional)
     * @return Success
     */
    autocompleteArtisteNom(search, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Artiste/autocomplete/nom?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAutocompleteArtisteNom(_response);
        });
    }
    processAutocompleteArtisteNom(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class AuthClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @return Success
     */
    getAuthInfo(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Auth/info";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetAuthInfo(_response);
        });
    }
    processGetAuthInfo(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    login(body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Auth/login";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processLogin(_response);
        });
    }
    processLogin(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    logout(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Auth/logout";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processLogout(_response);
        });
    }
    processLogout(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class BordereauClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @return Success
     */
    soumissionSignatureBordereau(bordereauId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Bordereau/{bordereauId}/soumission";
        if (bordereauId === undefined || bordereauId === null)
            throw new Error("The parameter 'bordereauId' must be defined.");
        url_ = url_.replace("{bordereauId}", encodeURIComponent("" + bordereauId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processSoumissionSignatureBordereau(_response);
        });
    }
    processSoumissionSignatureBordereau(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = resultData400;
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param typeBordereau (optional)
     * @return Success
     */
    getBordereaux(typeBordereau, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Bordereau?";
        if (typeBordereau === null)
            throw new Error("The parameter 'typeBordereau' cannot be null.");
        else if (typeBordereau !== undefined)
            url_ += "typeBordereau=" + encodeURIComponent("" + typeBordereau) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetBordereaux(_response);
        });
    }
    processGetBordereaux(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getBordereauBlocageVersement(bordereauId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Bordereau/{bordereauId}/blocage";
        if (bordereauId === undefined || bordereauId === null)
            throw new Error("The parameter 'bordereauId' must be defined.");
        url_ = url_.replace("{bordereauId}", encodeURIComponent("" + bordereauId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetBordereauBlocageVersement(_response);
        });
    }
    processGetBordereauBlocageVersement(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    removeBlockedVersement(bordereauId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Bordereau/{bordereauId}/remove";
        if (bordereauId === undefined || bordereauId === null)
            throw new Error("The parameter 'bordereauId' must be defined.");
        url_ = url_.replace("{bordereauId}", encodeURIComponent("" + bordereauId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PUT",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processRemoveBlockedVersement(_response);
        });
    }
    processRemoveBlockedVersement(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    clotureBordereauVersement(bordereauId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Bordereau/{bordereauId}/cloture";
        if (bordereauId === undefined || bordereauId === null)
            throw new Error("The parameter 'bordereauId' must be defined.");
        url_ = url_.replace("{bordereauId}", encodeURIComponent("" + bordereauId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processClotureBordereauVersement(_response);
        });
    }
    processClotureBordereauVersement(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = resultData400;
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    clotureBordereauReaffectation(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Bordereau/cloture";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processClotureBordereauReaffectation(_response);
        });
    }
    processClotureBordereauReaffectation(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getBordereauVersement(bordereauId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Bordereau/{bordereauId}/versement";
        if (bordereauId === undefined || bordereauId === null)
            throw new Error("The parameter 'bordereauId' must be defined.");
        url_ = url_.replace("{bordereauId}", encodeURIComponent("" + bordereauId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetBordereauVersement(_response);
        });
    }
    processGetBordereauVersement(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getBordereauVersementPreparatoire(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Bordereau/preparatoire/versement";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetBordereauVersementPreparatoire(_response);
        });
    }
    processGetBordereauVersementPreparatoire(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getBordereauReaffectation(bordereauId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Bordereau/{bordereauId}/reaffectation";
        if (bordereauId === undefined || bordereauId === null)
            throw new Error("The parameter 'bordereauId' must be defined.");
        url_ = url_.replace("{bordereauId}", encodeURIComponent("" + bordereauId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetBordereauReaffectation(_response);
        });
    }
    processGetBordereauReaffectation(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getBordereauReaffectationPreparatoire(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Bordereau/preparatoire/reaffectation";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetBordereauReaffectationPreparatoire(_response);
        });
    }
    processGetBordereauReaffectationPreparatoire(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getBordereauReaffectationAmendable(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Bordereau/amendable/reaffectation";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetBordereauReaffectationAmendable(_response);
        });
    }
    processGetBordereauReaffectationAmendable(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getMouvementsDemandeRemboursement(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Bordereau/mouvements/demandeRemboursement";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetMouvementsDemandeRemboursement(_response);
        });
    }
    processGetMouvementsDemandeRemboursement(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    createRemboursement(mouvementId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Bordereau/mouvements/{mouvementId}/rembourser";
        if (mouvementId === undefined || mouvementId === null)
            throw new Error("The parameter 'mouvementId' must be defined.");
        url_ = url_.replace("{mouvementId}", encodeURIComponent("" + mouvementId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateRemboursement(_response);
        });
    }
    processCreateRemboursement(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = resultData400;
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    deleteMouvement(mouvementId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Bordereau/mouvements/{mouvementId}";
        if (mouvementId === undefined || mouvementId === null)
            throw new Error("The parameter 'mouvementId' must be defined.");
        url_ = url_.replace("{mouvementId}", encodeURIComponent("" + mouvementId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeleteMouvement(_response);
        });
    }
    processDeleteMouvement(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 401) {
            const _responseText = response.data;
            let result401 = null;
            let resultData401 = _responseText;
            result401 = resultData401;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        }
        else if (status === 403) {
            const _responseText = response.data;
            let result403 = null;
            let resultData403 = _responseText;
            result403 = resultData403;
            return throwException("Forbidden", status, _responseText, _headers, result403);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    archiveBordereau(bordereauId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Bordereau/{bordereauId}/archive";
        if (bordereauId === undefined || bordereauId === null)
            throw new Error("The parameter 'bordereauId' must be defined.");
        url_ = url_.replace("{bordereauId}", encodeURIComponent("" + bordereauId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processArchiveBordereau(_response);
        });
    }
    processArchiveBordereau(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getBordereauVersementAsExcel(bordereauId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Bordereau/{bordereauId}/export";
        if (bordereauId === undefined || bordereauId === null)
            throw new Error("The parameter 'bordereauId' must be defined.");
        url_ = url_.replace("{bordereauId}", encodeURIComponent("" + bordereauId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetBordereauVersementAsExcel(_response);
        });
    }
    processGetBordereauVersementAsExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getBordereauVersementAsPDF(bordereauId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Bordereau/{bordereauId}/pdf";
        if (bordereauId === undefined || bordereauId === null)
            throw new Error("The parameter 'bordereauId' must be defined.");
        url_ = url_.replace("{bordereauId}", encodeURIComponent("" + bordereauId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetBordereauVersementAsPDF(_response);
        });
    }
    processGetBordereauVersementAsPDF(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = resultData400;
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getExportSEPA(bordereauId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Bordereau/{bordereauId}/sepa";
        if (bordereauId === undefined || bordereauId === null)
            throw new Error("The parameter 'bordereauId' must be defined.");
        url_ = url_.replace("{bordereauId}", encodeURIComponent("" + bordereauId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetExportSEPA(_response);
        });
    }
    processGetExportSEPA(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = resultData400;
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getBordereauVersementAsTxt(bordereauId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Bordereau/{bordereauId}/txt";
        if (bordereauId === undefined || bordereauId === null)
            throw new Error("The parameter 'bordereauId' must be defined.");
        url_ = url_.replace("{bordereauId}", encodeURIComponent("" + bordereauId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/txt"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetBordereauVersementAsTxt(_response);
        });
    }
    processGetBordereauVersementAsTxt(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = resultData400;
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class CategorieDossierClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @return Success
     */
    getCategoriesDossier(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/CategorieDossier";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetCategoriesDossier(_response);
        });
    }
    processGetCategoriesDossier(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getCritereDeDossierCommissions(categorieId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/CategorieDossier/{categorieId}/commissions";
        if (categorieId === undefined || categorieId === null)
            throw new Error("The parameter 'categorieId' must be defined.");
        url_ = url_.replace("{categorieId}", encodeURIComponent("" + categorieId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetCritereDeDossierCommissions(_response);
        });
    }
    processGetCritereDeDossierCommissions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getLastCritereDossier(categorieId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/CategorieDossier/{categorieId}/critereDossier";
        if (categorieId === undefined || categorieId === null)
            throw new Error("The parameter 'categorieId' must be defined.");
        url_ = url_.replace("{categorieId}", encodeURIComponent("" + categorieId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetLastCritereDossier(_response);
        });
    }
    processGetLastCritereDossier(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class CategorieFormeJuridiqueClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @return Success
     */
    getCategoriesFormeJuridique(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/CategorieFormeJuridique";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetCategoriesFormeJuridique(_response);
        });
    }
    processGetCategoriesFormeJuridique(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    createCategorieFormeJuridique(body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/CategorieFormeJuridique";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateCategorieFormeJuridique(_response);
        });
    }
    processCreateCategorieFormeJuridique(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve(result201);
        }
        else if (status === 409) {
            const _responseText = response.data;
            let result409 = null;
            let resultData409 = _responseText;
            result409 = resultData409;
            return throwException("Conflict", status, _responseText, _headers, result409);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateCategorieFormeJuridique(id, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/CategorieFormeJuridique/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateCategorieFormeJuridique(_response);
        });
    }
    processUpdateCategorieFormeJuridique(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    deleteCategorieFormeJuridique(id, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/CategorieFormeJuridique/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeleteCategorieFormeJuridique(_response);
        });
    }
    processDeleteCategorieFormeJuridique(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 409) {
            const _responseText = response.data;
            let result409 = null;
            let resultData409 = _responseText;
            result409 = resultData409;
            return throwException("Conflict", status, _responseText, _headers, result409);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Associate categories to types de documents.
    Each key of the dictionary is an ID of a category and each value is a list of IDs of the types de document associated to this category.
     * @param body (optional)
     * @return Success
     */
    updateCategoriesFormeJuridiqueTypesDeDocuments(body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/CategorieFormeJuridique/updateMapping";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateCategoriesFormeJuridiqueTypesDeDocuments(_response);
        });
    }
    processUpdateCategoriesFormeJuridiqueTypesDeDocuments(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class CommissionClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    createCommission(body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Commission";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateCommission(_response);
        });
    }
    processCreateCommission(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param filters (optional)
     * @param sorts (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param disablePagination (optional)
     * @param year (optional)
     * @return Success
     */
    getCommissions(filters, sorts, page, pageSize, disablePagination, year, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Commission?";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&";
        if (sorts === null)
            throw new Error("The parameter 'sorts' cannot be null.");
        else if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (disablePagination === null)
            throw new Error("The parameter 'disablePagination' cannot be null.");
        else if (disablePagination !== undefined)
            url_ += "DisablePagination=" + encodeURIComponent("" + disablePagination) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetCommissions(_response);
        });
    }
    processGetCommissions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateCommission(commissionId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Commission/{commissionId}";
        if (commissionId === undefined || commissionId === null)
            throw new Error("The parameter 'commissionId' must be defined.");
        url_ = url_.replace("{commissionId}", encodeURIComponent("" + commissionId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateCommission(_response);
        });
    }
    processUpdateCommission(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getCommission(commissionId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Commission/{commissionId}";
        if (commissionId === undefined || commissionId === null)
            throw new Error("The parameter 'commissionId' must be defined.");
        url_ = url_.replace("{commissionId}", encodeURIComponent("" + commissionId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetCommission(_response);
        });
    }
    processGetCommission(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param code (optional)
     * @return Success
     */
    getCommissionDossiers(commissionId, code, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Commission/{commissionId}/deroulement?";
        if (commissionId === undefined || commissionId === null)
            throw new Error("The parameter 'commissionId' must be defined.");
        url_ = url_.replace("{commissionId}", encodeURIComponent("" + commissionId));
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetCommissionDossiers(_response);
        });
    }
    processGetCommissionDossiers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param filters (optional)
     * @param sorts (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param disablePagination (optional)
     * @return Success
     */
    getCommissionListingDossiers(commissionId, filters, sorts, page, pageSize, disablePagination, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Commission/{commissionId}/dossiers?";
        if (commissionId === undefined || commissionId === null)
            throw new Error("The parameter 'commissionId' must be defined.");
        url_ = url_.replace("{commissionId}", encodeURIComponent("" + commissionId));
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&";
        if (sorts === null)
            throw new Error("The parameter 'sorts' cannot be null.");
        else if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (disablePagination === null)
            throw new Error("The parameter 'disablePagination' cannot be null.");
        else if (disablePagination !== undefined)
            url_ += "DisablePagination=" + encodeURIComponent("" + disablePagination) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetCommissionListingDossiers(_response);
        });
    }
    processGetCommissionListingDossiers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param filters (optional)
     * @param sorts (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param disablePagination (optional)
     * @return Success
     */
    getSessionCADossiers(commissionId, filters, sorts, page, pageSize, disablePagination, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Commission/{commissionId}/dossiers/ca?";
        if (commissionId === undefined || commissionId === null)
            throw new Error("The parameter 'commissionId' must be defined.");
        url_ = url_.replace("{commissionId}", encodeURIComponent("" + commissionId));
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&";
        if (sorts === null)
            throw new Error("The parameter 'sorts' cannot be null.");
        else if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (disablePagination === null)
            throw new Error("The parameter 'disablePagination' cannot be null.");
        else if (disablePagination !== undefined)
            url_ += "DisablePagination=" + encodeURIComponent("" + disablePagination) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetSessionCADossiers(_response);
        });
    }
    processGetSessionCADossiers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getCommissionDossiersAsExcel(commissionId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Commission/{commissionId}/dossiers/export";
        if (commissionId === undefined || commissionId === null)
            throw new Error("The parameter 'commissionId' must be defined.");
        url_ = url_.replace("{commissionId}", encodeURIComponent("" + commissionId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetCommissionDossiersAsExcel(_response);
        });
    }
    processGetCommissionDossiersAsExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getCommissionDossiersAccepteAsExcel(commissionId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Commission/{commissionId}/dossiers/accepte/export";
        if (commissionId === undefined || commissionId === null)
            throw new Error("The parameter 'commissionId' must be defined.");
        url_ = url_.replace("{commissionId}", encodeURIComponent("" + commissionId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetCommissionDossiersAccepteAsExcel(_response);
        });
    }
    processGetCommissionDossiersAccepteAsExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param filters (optional)
     * @param sorts (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param disablePagination (optional)
     * @return Success
     */
    getSessionsCA(filters, sorts, page, pageSize, disablePagination, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Commission/ca?";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&";
        if (sorts === null)
            throw new Error("The parameter 'sorts' cannot be null.");
        else if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (disablePagination === null)
            throw new Error("The parameter 'disablePagination' cannot be null.");
        else if (disablePagination !== undefined)
            url_ += "DisablePagination=" + encodeURIComponent("" + disablePagination) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetSessionsCA(_response);
        });
    }
    processGetSessionsCA(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getCommissionsStartingDate(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Commission/startingdate";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetCommissionsStartingDate(_response);
        });
    }
    processGetCommissionsStartingDate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getCommissionsForDossier(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Commission/{dossierId}/commissions";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetCommissionsForDossier(_response);
        });
    }
    processGetCommissionsForDossier(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getCommissionTableauBord(commissionId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Commission/{commissionId}/tableaubord";
        if (commissionId === undefined || commissionId === null)
            throw new Error("The parameter 'commissionId' must be defined.");
        url_ = url_.replace("{commissionId}", encodeURIComponent("" + commissionId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetCommissionTableauBord(_response);
        });
    }
    processGetCommissionTableauBord(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getCommissionDossiersGenerationErrors(commissionId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Commission/{commissionId}/errors";
        if (commissionId === undefined || commissionId === null)
            throw new Error("The parameter 'commissionId' must be defined.");
        url_ = url_.replace("{commissionId}", encodeURIComponent("" + commissionId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetCommissionDossiersGenerationErrors(_response);
        });
    }
    processGetCommissionDossiersGenerationErrors(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    figeCommissionStatut(commissionId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Commission/{commissionId}/figeStatut";
        if (commissionId === undefined || commissionId === null)
            throw new Error("The parameter 'commissionId' must be defined.");
        url_ = url_.replace("{commissionId}", encodeURIComponent("" + commissionId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PUT",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processFigeCommissionStatut(_response);
        });
    }
    processFigeCommissionStatut(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    openCommission(commissionId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Commission/{commissionId}/open";
        if (commissionId === undefined || commissionId === null)
            throw new Error("The parameter 'commissionId' must be defined.");
        url_ = url_.replace("{commissionId}", encodeURIComponent("" + commissionId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processOpenCommission(_response);
        });
    }
    processOpenCommission(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = resultData400;
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getCommissionHasParticipation(commissionId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Commission/{commissionId}/participation";
        if (commissionId === undefined || commissionId === null)
            throw new Error("The parameter 'commissionId' must be defined.");
        url_ = url_.replace("{commissionId}", encodeURIComponent("" + commissionId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetCommissionHasParticipation(_response);
        });
    }
    processGetCommissionHasParticipation(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    openSessionCA(commissionId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Commission/{commissionId}/openca";
        if (commissionId === undefined || commissionId === null)
            throw new Error("The parameter 'commissionId' must be defined.");
        url_ = url_.replace("{commissionId}", encodeURIComponent("" + commissionId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PUT",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processOpenSessionCA(_response);
        });
    }
    processOpenSessionCA(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = resultData400;
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getCommissionMembers(commissionId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Commission/{commissionId}/members";
        if (commissionId === undefined || commissionId === null)
            throw new Error("The parameter 'commissionId' must be defined.");
        url_ = url_.replace("{commissionId}", encodeURIComponent("" + commissionId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetCommissionMembers(_response);
        });
    }
    processGetCommissionMembers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param filters (optional)
     * @param sorts (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param disablePagination (optional)
     * @return Success
     */
    getCommissionSigningSheetsPdf(commissionId, filters, sorts, page, pageSize, disablePagination, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Commission/{commissionId}/members/signingsheets?";
        if (commissionId === undefined || commissionId === null)
            throw new Error("The parameter 'commissionId' must be defined.");
        url_ = url_.replace("{commissionId}", encodeURIComponent("" + commissionId));
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&";
        if (sorts === null)
            throw new Error("The parameter 'sorts' cannot be null.");
        else if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (disablePagination === null)
            throw new Error("The parameter 'disablePagination' cannot be null.");
        else if (disablePagination !== undefined)
            url_ += "DisablePagination=" + encodeURIComponent("" + disablePagination) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/pdf"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetCommissionSigningSheetsPdf(_response);
        });
    }
    processGetCommissionSigningSheetsPdf(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getCommissionEnveloppesBudgetaires(commissionId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Commission/{commissionId}/enveloppesBudgetaires";
        if (commissionId === undefined || commissionId === null)
            throw new Error("The parameter 'commissionId' must be defined.");
        url_ = url_.replace("{commissionId}", encodeURIComponent("" + commissionId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetCommissionEnveloppesBudgetaires(_response);
        });
    }
    processGetCommissionEnveloppesBudgetaires(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateCommissionEnveloppesBudgetaires(commissionId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Commission/{commissionId}/enveloppesBudgetaires";
        if (commissionId === undefined || commissionId === null)
            throw new Error("The parameter 'commissionId' must be defined.");
        url_ = url_.replace("{commissionId}", encodeURIComponent("" + commissionId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateCommissionEnveloppesBudgetaires(_response);
        });
    }
    processUpdateCommissionEnveloppesBudgetaires(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    closeCommission(commissionId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Commission/{commissionId}/close";
        if (commissionId === undefined || commissionId === null)
            throw new Error("The parameter 'commissionId' must be defined.");
        url_ = url_.replace("{commissionId}", encodeURIComponent("" + commissionId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCloseCommission(_response);
        });
    }
    processCloseCommission(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    closeSessionCA(commissionId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Commission/{commissionId}/closeCA";
        if (commissionId === undefined || commissionId === null)
            throw new Error("The parameter 'commissionId' must be defined.");
        url_ = url_.replace("{commissionId}", encodeURIComponent("" + commissionId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PUT",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCloseSessionCA(_response);
        });
    }
    processCloseSessionCA(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    regenerateCommissionDocuments(commissionId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Commission/{commissionId}/regenerate";
        if (commissionId === undefined || commissionId === null)
            throw new Error("The parameter 'commissionId' must be defined.");
        url_ = url_.replace("{commissionId}", encodeURIComponent("" + commissionId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processRegenerateCommissionDocuments(_response);
        });
    }
    processRegenerateCommissionDocuments(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateCommissionContent(commissionId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Commission/{commissionId}/content";
        if (commissionId === undefined || commissionId === null)
            throw new Error("The parameter 'commissionId' must be defined.");
        url_ = url_.replace("{commissionId}", encodeURIComponent("" + commissionId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateCommissionContent(_response);
        });
    }
    processUpdateCommissionContent(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateCommissionCAContent(commissionId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Commission/{commissionId}/contentCA";
        if (commissionId === undefined || commissionId === null)
            throw new Error("The parameter 'commissionId' must be defined.");
        url_ = url_.replace("{commissionId}", encodeURIComponent("" + commissionId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateCommissionCAContent(_response);
        });
    }
    processUpdateCommissionCAContent(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateCommissionMemberList(commissionId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Commission/{commissionId}/memberlist/update";
        if (commissionId === undefined || commissionId === null)
            throw new Error("The parameter 'commissionId' must be defined.");
        url_ = url_.replace("{commissionId}", encodeURIComponent("" + commissionId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateCommissionMemberList(_response);
        });
    }
    processUpdateCommissionMemberList(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getCommissionDossiersCountForCourriers(commissionId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Commission/{commissionId}/count";
        if (commissionId === undefined || commissionId === null)
            throw new Error("The parameter 'commissionId' must be defined.");
        url_ = url_.replace("{commissionId}", encodeURIComponent("" + commissionId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetCommissionDossiersCountForCourriers(_response);
        });
    }
    processGetCommissionDossiersCountForCourriers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getDossiersDSVFromCommissionAsExcel(commissionId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Commission/{commissionId}/export";
        if (commissionId === undefined || commissionId === null)
            throw new Error("The parameter 'commissionId' must be defined.");
        url_ = url_.replace("{commissionId}", encodeURIComponent("" + commissionId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDossiersDSVFromCommissionAsExcel(_response);
        });
    }
    processGetDossiersDSVFromCommissionAsExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param code (optional)
     * @return Success
     */
    getCommissionCourrierCommunication(commissionId, code, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Commission/{commissionId}/communication?";
        if (commissionId === undefined || commissionId === null)
            throw new Error("The parameter 'commissionId' must be defined.");
        url_ = url_.replace("{commissionId}", encodeURIComponent("" + commissionId));
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/pdf"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetCommissionCourrierCommunication(_response);
        });
    }
    processGetCommissionCourrierCommunication(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = resultData400;
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getCommissionPlanComptable(commissionId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Commission/{commissionId}/plancompta";
        if (commissionId === undefined || commissionId === null)
            throw new Error("The parameter 'commissionId' must be defined.");
        url_ = url_.replace("{commissionId}", encodeURIComponent("" + commissionId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/txt"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetCommissionPlanComptable(_response);
        });
    }
    processGetCommissionPlanComptable(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param onCa (optional)
     * @return Success
     */
    getCommissionEcritureAttribution(commissionId, onCa, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Commission/{commissionId}/attribution?";
        if (commissionId === undefined || commissionId === null)
            throw new Error("The parameter 'commissionId' must be defined.");
        url_ = url_.replace("{commissionId}", encodeURIComponent("" + commissionId));
        if (onCa === null)
            throw new Error("The parameter 'onCa' cannot be null.");
        else if (onCa !== undefined)
            url_ += "onCa=" + encodeURIComponent("" + onCa) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/zip"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetCommissionEcritureAttribution(_response);
        });
    }
    processGetCommissionEcritureAttribution(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getCommissionEcritureReaffectation(commissionId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Commission/{commissionId}/reaffectation";
        if (commissionId === undefined || commissionId === null)
            throw new Error("The parameter 'commissionId' must be defined.");
        url_ = url_.replace("{commissionId}", encodeURIComponent("" + commissionId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/zip"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetCommissionEcritureReaffectation(_response);
        });
    }
    processGetCommissionEcritureReaffectation(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class CommissionMemberClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    createCommissionMember(body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/CommissionMember/createCommissionMember";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateCommissionMember(_response);
        });
    }
    processCreateCommissionMember(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateCommissionMember(commissionMemberId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/CommissionMember/{commissionMemberId}";
        if (commissionMemberId === undefined || commissionMemberId === null)
            throw new Error("The parameter 'commissionMemberId' must be defined.");
        url_ = url_.replace("{commissionMemberId}", encodeURIComponent("" + commissionMemberId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateCommissionMember(_response);
        });
    }
    processUpdateCommissionMember(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getCommissionsMember(commissionMemberId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/CommissionMember/{commissionMemberId}";
        if (commissionMemberId === undefined || commissionMemberId === null)
            throw new Error("The parameter 'commissionMemberId' must be defined.");
        url_ = url_.replace("{commissionMemberId}", encodeURIComponent("" + commissionMemberId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetCommissionsMember(_response);
        });
    }
    processGetCommissionsMember(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param filters (optional)
     * @param sorts (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param disablePagination (optional)
     * @return Success
     */
    getCommissionsMembers(filters, sorts, page, pageSize, disablePagination, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/CommissionMember?";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&";
        if (sorts === null)
            throw new Error("The parameter 'sorts' cannot be null.");
        else if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (disablePagination === null)
            throw new Error("The parameter 'disablePagination' cannot be null.");
        else if (disablePagination !== undefined)
            url_ += "DisablePagination=" + encodeURIComponent("" + disablePagination) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetCommissionsMembers(_response);
        });
    }
    processGetCommissionsMembers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class ComptabiliteClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @param dateExport (optional)
     * @return Success
     */
    getDossierNonSoldeAsExcel(dateExport, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Comptabilite/export?";
        if (dateExport === null)
            throw new Error("The parameter 'dateExport' cannot be null.");
        else if (dateExport !== undefined)
            url_ += "dateExport=" + encodeURIComponent(dateExport ? "" + dateExport.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDossierNonSoldeAsExcel(_response);
        });
    }
    processGetDossierNonSoldeAsExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class CompteBancaireClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    createOrUpdateCompteBancaire(body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/CompteBancaire/compte";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateOrUpdateCompteBancaire(_response);
        });
    }
    processCreateOrUpdateCompteBancaire(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getAllComptesBancaires(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/CompteBancaire/comptes";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetAllComptesBancaires(_response);
        });
    }
    processGetAllComptesBancaires(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    deleteCompteBancaire(compteBancaireId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/CompteBancaire/{compteBancaireId}";
        if (compteBancaireId === undefined || compteBancaireId === null)
            throw new Error("The parameter 'compteBancaireId' must be defined.");
        url_ = url_.replace("{compteBancaireId}", encodeURIComponent("" + compteBancaireId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeleteCompteBancaire(_response);
        });
    }
    processDeleteCompteBancaire(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class DiscussionClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    createDiscussionStructure(structureId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Discussion/structure/{structureId}";
        if (structureId === undefined || structureId === null)
            throw new Error("The parameter 'structureId' must be defined.");
        url_ = url_.replace("{structureId}", encodeURIComponent("" + structureId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateDiscussionStructure(_response);
        });
    }
    processCreateDiscussionStructure(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve(result201);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getDiscussionsStructure(structureId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Discussion/structure/{structureId}";
        if (structureId === undefined || structureId === null)
            throw new Error("The parameter 'structureId' must be defined.");
        url_ = url_.replace("{structureId}", encodeURIComponent("" + structureId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDiscussionsStructure(_response);
        });
    }
    processGetDiscussionsStructure(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    createDiscussionDossier(dossierId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Discussion/dossier/{dossierId}";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateDiscussionDossier(_response);
        });
    }
    processCreateDiscussionDossier(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve(result201);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getDiscussionsDossier(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Discussion/dossier/{dossierId}";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDiscussionsDossier(_response);
        });
    }
    processGetDiscussionsDossier(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param contenu (optional)
     * @param piecesJointes (optional)
     * @return Success
     */
    createMessageDiscussion(discussionId, contenu, piecesJointes, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Discussion/{discussionId}/message";
        if (discussionId === undefined || discussionId === null)
            throw new Error("The parameter 'discussionId' must be defined.");
        url_ = url_.replace("{discussionId}", encodeURIComponent("" + discussionId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (contenu === null || contenu === undefined)
            throw new Error("The parameter 'contenu' cannot be null.");
        else
            content_.append("Contenu", contenu.toString());
        if (piecesJointes === null || piecesJointes === undefined)
            throw new Error("The parameter 'piecesJointes' cannot be null.");
        else
            piecesJointes.forEach(item_ => content_.append("PiecesJointes", item_.data, item_.fileName ? item_.fileName : "PiecesJointes"));
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateMessageDiscussion(_response);
        });
    }
    processCreateMessageDiscussion(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve(result201);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param filters (optional)
     * @param sorts (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param disablePagination (optional)
     * @param contenu (optional)
     * @param piecesJointes (optional)
     * @return Success
     */
    createMultipleDossierDiscussion(filters, sorts, page, pageSize, disablePagination, contenu, piecesJointes, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Discussion/dossier/multiple?";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&";
        if (sorts === null)
            throw new Error("The parameter 'sorts' cannot be null.");
        else if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (disablePagination === null)
            throw new Error("The parameter 'disablePagination' cannot be null.");
        else if (disablePagination !== undefined)
            url_ += "DisablePagination=" + encodeURIComponent("" + disablePagination) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (contenu === null || contenu === undefined)
            throw new Error("The parameter 'contenu' cannot be null.");
        else
            content_.append("Contenu", contenu.toString());
        if (piecesJointes === null || piecesJointes === undefined)
            throw new Error("The parameter 'piecesJointes' cannot be null.");
        else
            piecesJointes.forEach(item_ => content_.append("PiecesJointes", item_.data, item_.fileName ? item_.fileName : "PiecesJointes"));
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateMultipleDossierDiscussion(_response);
        });
    }
    processCreateMultipleDossierDiscussion(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param filters (optional)
     * @param sorts (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param disablePagination (optional)
     * @param contenu (optional)
     * @param piecesJointes (optional)
     * @return Success
     */
    createMultipleStructureDiscussion(filters, sorts, page, pageSize, disablePagination, contenu, piecesJointes, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Discussion/structure/multiple?";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&";
        if (sorts === null)
            throw new Error("The parameter 'sorts' cannot be null.");
        else if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (disablePagination === null)
            throw new Error("The parameter 'disablePagination' cannot be null.");
        else if (disablePagination !== undefined)
            url_ += "DisablePagination=" + encodeURIComponent("" + disablePagination) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (contenu === null || contenu === undefined)
            throw new Error("The parameter 'contenu' cannot be null.");
        else
            content_.append("Contenu", contenu.toString());
        if (piecesJointes === null || piecesJointes === undefined)
            throw new Error("The parameter 'piecesJointes' cannot be null.");
        else
            piecesJointes.forEach(item_ => content_.append("PiecesJointes", item_.data, item_.fileName ? item_.fileName : "PiecesJointes"));
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateMultipleStructureDiscussion(_response);
        });
    }
    processCreateMultipleStructureDiscussion(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateStatutDiscussion(discussionId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Discussion/{discussionId}";
        if (discussionId === undefined || discussionId === null)
            throw new Error("The parameter 'discussionId' must be defined.");
        url_ = url_.replace("{discussionId}", encodeURIComponent("" + discussionId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateStatutDiscussion(_response);
        });
    }
    processUpdateStatutDiscussion(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getObjetsDiscussionsDossier(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Discussion/dossier/objets";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetObjetsDiscussionsDossier(_response);
        });
    }
    processGetObjetsDiscussionsDossier(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getObjetsDiscussionsStructure(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Discussion/structure/objets";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetObjetsDiscussionsStructure(_response);
        });
    }
    processGetObjetsDiscussionsStructure(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    setDiscussionLu(discussionId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Discussion/{discussionId}/lu";
        if (discussionId === undefined || discussionId === null)
            throw new Error("The parameter 'discussionId' must be defined.");
        url_ = url_.replace("{discussionId}", encodeURIComponent("" + discussionId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processSetDiscussionLu(_response);
        });
    }
    processSetDiscussionLu(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class DossierClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @param filters (optional)
     * @param sorts (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param disablePagination (optional)
     * @param artisteNom (optional)
     * @param artistePrenom (optional)
     * @return Success
     */
    getDossiers(filters, sorts, page, pageSize, disablePagination, artisteNom, artistePrenom, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier?";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&";
        if (sorts === null)
            throw new Error("The parameter 'sorts' cannot be null.");
        else if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (disablePagination === null)
            throw new Error("The parameter 'disablePagination' cannot be null.");
        else if (disablePagination !== undefined)
            url_ += "DisablePagination=" + encodeURIComponent("" + disablePagination) + "&";
        if (artisteNom === null)
            throw new Error("The parameter 'artisteNom' cannot be null.");
        else if (artisteNom !== undefined)
            url_ += "artisteNom=" + encodeURIComponent("" + artisteNom) + "&";
        if (artistePrenom === null)
            throw new Error("The parameter 'artistePrenom' cannot be null.");
        else if (artistePrenom !== undefined)
            url_ += "artistePrenom=" + encodeURIComponent("" + artistePrenom) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDossiers(_response);
        });
    }
    processGetDossiers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param filters (optional)
     * @param sorts (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param disablePagination (optional)
     * @return Success
     */
    getDossierFilteredAsExcel(filters, sorts, page, pageSize, disablePagination, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/export?";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&";
        if (sorts === null)
            throw new Error("The parameter 'sorts' cannot be null.");
        else if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (disablePagination === null)
            throw new Error("The parameter 'disablePagination' cannot be null.");
        else if (disablePagination !== undefined)
            url_ += "DisablePagination=" + encodeURIComponent("" + disablePagination) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDossierFilteredAsExcel(_response);
        });
    }
    processGetDossierFilteredAsExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getDossierInstruction(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/instruction";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDossierInstruction(_response);
        });
    }
    processGetDossierInstruction(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param statut (optional)
     * @param chargeInstructionId (optional)
     * @param commissionId (optional)
     * @param dSV (optional)
     * @param blocageJuridique (optional)
     * @param blocageAvis (optional)
     * @param motifBlocageJuridique (optional)
     * @param rIBModifiableParStructure (optional)
     * @param modifiableParStructure (optional)
     * @param commentairesInstruction (optional)
     * @param subCategorieId (optional)
     * @param documents (optional)
     * @param files (optional)
     * @return Success
     */
    updateDossierInstruction(dossierId, statut, chargeInstructionId, commissionId, dSV, blocageJuridique, blocageAvis, motifBlocageJuridique, rIBModifiableParStructure, modifiableParStructure, commentairesInstruction, subCategorieId, documents, files, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/instruction";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (statut === null || statut === undefined)
            throw new Error("The parameter 'statut' cannot be null.");
        else
            content_.append("Statut", statut.toString());
        if (chargeInstructionId === null || chargeInstructionId === undefined)
            throw new Error("The parameter 'chargeInstructionId' cannot be null.");
        else
            content_.append("ChargeInstructionId", chargeInstructionId.toString());
        if (commissionId === null || commissionId === undefined)
            throw new Error("The parameter 'commissionId' cannot be null.");
        else
            content_.append("CommissionId", commissionId.toString());
        if (dSV === null || dSV === undefined)
            throw new Error("The parameter 'dSV' cannot be null.");
        else
            content_.append("DSV", dSV.toString());
        if (blocageJuridique === null || blocageJuridique === undefined)
            throw new Error("The parameter 'blocageJuridique' cannot be null.");
        else
            content_.append("BlocageJuridique", blocageJuridique.toString());
        if (blocageAvis === null || blocageAvis === undefined)
            throw new Error("The parameter 'blocageAvis' cannot be null.");
        else
            content_.append("BlocageAvis", blocageAvis.toString());
        if (motifBlocageJuridique === null || motifBlocageJuridique === undefined)
            throw new Error("The parameter 'motifBlocageJuridique' cannot be null.");
        else
            content_.append("MotifBlocageJuridique", motifBlocageJuridique.toString());
        if (rIBModifiableParStructure === null || rIBModifiableParStructure === undefined)
            throw new Error("The parameter 'rIBModifiableParStructure' cannot be null.");
        else
            content_.append("RIBModifiableParStructure", rIBModifiableParStructure.toString());
        if (modifiableParStructure === null || modifiableParStructure === undefined)
            throw new Error("The parameter 'modifiableParStructure' cannot be null.");
        else
            content_.append("ModifiableParStructure", modifiableParStructure.toString());
        if (commentairesInstruction === null || commentairesInstruction === undefined)
            throw new Error("The parameter 'commentairesInstruction' cannot be null.");
        else
            content_.append("CommentairesInstruction", commentairesInstruction.toString());
        if (subCategorieId === null || subCategorieId === undefined)
            throw new Error("The parameter 'subCategorieId' cannot be null.");
        else
            content_.append("SubCategorieId", subCategorieId.toString());
        if (documents === null || documents === undefined)
            throw new Error("The parameter 'documents' cannot be null.");
        else
            documents.forEach(item_ => content_.append("Documents", item_.toString()));
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files"));
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateDossierInstruction(_response);
        });
    }
    processUpdateDossierInstruction(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getDossierCommission(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/commission";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDossierCommission(_response);
        });
    }
    processGetDossierCommission(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param structureId (optional)
     * @param search (optional)
     * @return Success
     */
    autocompleteResponsable(structureId, search, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/autocomplete/responsable?";
        if (structureId === null)
            throw new Error("The parameter 'structureId' cannot be null.");
        else if (structureId !== undefined)
            url_ += "structureId=" + encodeURIComponent("" + structureId) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAutocompleteResponsable(_response);
        });
    }
    processAutocompleteResponsable(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param search (optional)
     * @return Success
     */
    autocompleteResponsablePrenom(search, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/autocomplete/responsable/prenom?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAutocompleteResponsablePrenom(_response);
        });
    }
    processAutocompleteResponsablePrenom(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param search (optional)
     * @return Success
     */
    autocompleteResponsableNom(search, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/autocomplete/responsable/nom?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAutocompleteResponsableNom(_response);
        });
    }
    processAutocompleteResponsableNom(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param search (optional)
     * @return Success
     */
    autocompleteChargeInstructionNom(search, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/autocomplete/chargeInstruction/nom?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAutocompleteChargeInstructionNom(_response);
        });
    }
    processAutocompleteChargeInstructionNom(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param search (optional)
     * @return Success
     */
    autocompleteChargeInstructionPrenom(search, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/autocomplete/chargeInstruction/prenom?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAutocompleteChargeInstructionPrenom(_response);
        });
    }
    processAutocompleteChargeInstructionPrenom(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param langue (optional)
     * @return Success
     */
    getCurrentCriteresPdf(categorieId, langue, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/categorie/{categorieId}/critere/currentPdf?";
        if (categorieId === undefined || categorieId === null)
            throw new Error("The parameter 'categorieId' must be defined.");
        url_ = url_.replace("{categorieId}", encodeURIComponent("" + categorieId));
        if (langue === null)
            throw new Error("The parameter 'langue' cannot be null.");
        else if (langue !== undefined)
            url_ += "langue=" + encodeURIComponent("" + langue) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/pdf"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetCurrentCriteresPdf(_response);
        });
    }
    processGetCurrentCriteresPdf(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param langue (optional)
     * @return Success
     */
    getCriteresPdf(critereId, langue, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/critere/{critereId}/pdf?";
        if (critereId === undefined || critereId === null)
            throw new Error("The parameter 'critereId' must be defined.");
        url_ = url_.replace("{critereId}", encodeURIComponent("" + critereId));
        if (langue === null)
            throw new Error("The parameter 'langue' cannot be null.");
        else if (langue !== undefined)
            url_ += "langue=" + encodeURIComponent("" + langue) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/pdf"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetCriteresPdf(_response);
        });
    }
    processGetCriteresPdf(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Returns a list of critere dossier
     * @param categorieId (optional)
     * @param version (optional)
     * @param sortBy (optional)
     * @param sortDirection (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getCriteresDossier(categorieId, version, sortBy, sortDirection, page, pageSize, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/critere?";
        if (categorieId === null)
            throw new Error("The parameter 'categorieId' cannot be null.");
        else if (categorieId !== undefined)
            url_ += "CategorieId=" + encodeURIComponent("" + categorieId) + "&";
        if (version === null)
            throw new Error("The parameter 'version' cannot be null.");
        else if (version !== undefined)
            url_ += "Version=" + encodeURIComponent("" + version) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetCriteresDossier(_response);
        });
    }
    processGetCriteresDossier(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    createCritereDossier(body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/critere";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateCritereDossier(_response);
        });
    }
    processCreateCritereDossier(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve(result201);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getCritereDossier(critereId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/critere/{critereId}";
        if (critereId === undefined || critereId === null)
            throw new Error("The parameter 'critereId' must be defined.");
        url_ = url_.replace("{critereId}", encodeURIComponent("" + critereId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetCritereDossier(_response);
        });
    }
    processGetCritereDossier(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateCritereDossier(critereId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/critere/{critereId}";
        if (critereId === undefined || critereId === null)
            throw new Error("The parameter 'critereId' must be defined.");
        url_ = url_.replace("{critereId}", encodeURIComponent("" + critereId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateCritereDossier(_response);
        });
    }
    processUpdateCritereDossier(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = resultData400;
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    deleteCritereDossier(critereId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/critere/{critereId}";
        if (critereId === undefined || critereId === null)
            throw new Error("The parameter 'critereId' must be defined.");
        url_ = url_.replace("{critereId}", encodeURIComponent("" + critereId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeleteCritereDossier(_response);
        });
    }
    processDeleteCritereDossier(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateDossierNote(dossierId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/note";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateDossierNote(_response);
        });
    }
    processUpdateDossierNote(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getDossierNote(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/note";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDossierNote(_response);
        });
    }
    processGetDossierNote(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateDossierMontantCA(dossierId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/montantca";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateDossierMontantCA(_response);
        });
    }
    processUpdateDossierMontantCA(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param filters (optional)
     * @param sorts (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param disablePagination (optional)
     * @return Success
     */
    getDossierHistory(filters, sorts, page, pageSize, disablePagination, dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/history?";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&";
        if (sorts === null)
            throw new Error("The parameter 'sorts' cannot be null.");
        else if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (disablePagination === null)
            throw new Error("The parameter 'disablePagination' cannot be null.");
        else if (disablePagination !== undefined)
            url_ += "DisablePagination=" + encodeURIComponent("" + disablePagination) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDossierHistory(_response);
        });
    }
    processGetDossierHistory(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getDossierNotation(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/notation";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDossierNotation(_response);
        });
    }
    processGetDossierNotation(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getDossierDetails(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/details";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDossierDetails(_response);
        });
    }
    processGetDossierDetails(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param dateProlongation (optional)
     * @param commentaires (optional)
     * @param documents (optional)
     * @param files (optional)
     * @return Success
     */
    updateDossierDetails(dossierId, dateProlongation, commentaires, documents, files, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/details";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (dateProlongation === null || dateProlongation === undefined)
            throw new Error("The parameter 'dateProlongation' cannot be null.");
        else
            content_.append("DateProlongation", dateProlongation.toJSON());
        if (commentaires === null || commentaires === undefined)
            throw new Error("The parameter 'commentaires' cannot be null.");
        else
            content_.append("Commentaires", commentaires.toString());
        if (documents === null || documents === undefined)
            throw new Error("The parameter 'documents' cannot be null.");
        else
            documents.forEach(item_ => content_.append("Documents", item_.toString()));
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files"));
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateDossierDetails(_response);
        });
    }
    processUpdateDossierDetails(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getDossierAidHistory(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/aidhistory";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDossierAidHistory(_response);
        });
    }
    processGetDossierAidHistory(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getDossierVersement(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/versement";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDossierVersement(_response);
        });
    }
    processGetDossierVersement(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateDossierDocumentsValidation(dossierId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/documents/validation";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateDossierDocumentsValidation(_response);
        });
    }
    processUpdateDossierDocumentsValidation(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getSubCategoriesDossier(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/subCategoriesDossier";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetSubCategoriesDossier(_response);
        });
    }
    processGetSubCategoriesDossier(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getDossierDSV(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/dossierDSV";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDossierDSV(_response);
        });
    }
    processGetDossierDSV(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateDossierDSV(dossierId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/dossierDSV";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateDossierDSV(_response);
        });
    }
    processUpdateDossierDSV(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    prendreEnChargeDossier(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/prendreEnCharge";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PUT",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processPrendreEnChargeDossier(_response);
        });
    }
    processPrendreEnChargeDossier(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    prendreEnChargeDossierVersement(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/versements/prendreEnCharge";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processPrendreEnChargeDossierVersement(_response);
        });
    }
    processPrendreEnChargeDossierVersement(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = resultData400;
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    programmerEnCommissionDossier(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/programmerEnCommission";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PUT",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processProgrammerEnCommissionDossier(_response);
        });
    }
    processProgrammerEnCommissionDossier(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getDossierAdditionalInfo(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/additionalInfo";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDossierAdditionalInfo(_response);
        });
    }
    processGetDossierAdditionalInfo(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getDossierValidationViewModel(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/validation/viewmodel";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDossierValidationViewModel(_response);
        });
    }
    processGetDossierValidationViewModel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    validateDossier(dossierId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/validation";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processValidateDossier(_response);
        });
    }
    processValidateDossier(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param dateSignature (optional)
     * @return Success
     */
    updateDossierAgreement(dossierId, dateSignature, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/agreement/update?";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        if (dateSignature === null)
            throw new Error("The parameter 'dateSignature' cannot be null.");
        else if (dateSignature !== undefined)
            url_ += "dateSignature=" + encodeURIComponent(dateSignature ? "" + dateSignature.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PUT",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateDossierAgreement(_response);
        });
    }
    processUpdateDossierAgreement(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param filters (optional)
     * @param sorts (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param disablePagination (optional)
     * @return Success
     */
    getDossierVersements(filters, sorts, page, pageSize, disablePagination, dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/versements?";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&";
        if (sorts === null)
            throw new Error("The parameter 'sorts' cannot be null.");
        else if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (disablePagination === null)
            throw new Error("The parameter 'disablePagination' cannot be null.");
        else if (disablePagination !== undefined)
            url_ += "DisablePagination=" + encodeURIComponent("" + disablePagination) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDossierVersements(_response);
        });
    }
    processGetDossierVersements(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getDossierMouvements(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/mouvements";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDossierMouvements(_response);
        });
    }
    processGetDossierMouvements(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getDossierSyntheseFinanciere(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/synthese";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDossierSyntheseFinanciere(_response);
        });
    }
    processGetDossierSyntheseFinanciere(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = resultData400;
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    ajoutEvenementFinancier(dossierId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/ajout";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAjoutEvenementFinancier(_response);
        });
    }
    processAjoutEvenementFinancier(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getEvenementsFinanciersViewModel(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/evenementsvm";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetEvenementsFinanciersViewModel(_response);
        });
    }
    processGetEvenementsFinanciersViewModel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = resultData400;
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getDoublonsApi(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/doublonsapi";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDoublonsApi(_response);
        });
    }
    processGetDoublonsApi(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getDoublonsArtiste(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/doublonsartiste";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDoublonsArtiste(_response);
        });
    }
    processGetDoublonsArtiste(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateDossierDepenseMontantRealise(dossierId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/depenses/montantsrealises/update";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateDossierDepenseMontantRealise(_response);
        });
    }
    processUpdateDossierDepenseMontantRealise(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param filters (optional)
     * @param sorts (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param disablePagination (optional)
     * @return Success
     */
    getArtistes(dossierId, filters, sorts, page, pageSize, disablePagination, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/artistes?";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&";
        if (sorts === null)
            throw new Error("The parameter 'sorts' cannot be null.");
        else if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (disablePagination === null)
            throw new Error("The parameter 'disablePagination' cannot be null.");
        else if (disablePagination !== undefined)
            url_ += "DisablePagination=" + encodeURIComponent("" + disablePagination) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetArtistes(_response);
        });
    }
    processGetArtistes(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 403) {
            const _responseText = response.data;
            let result403 = null;
            let resultData403 = _responseText;
            result403 = resultData403;
            return throwException("Forbidden", status, _responseText, _headers, result403);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getArtistesViewModel(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/artistes/viewmodel";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetArtistesViewModel(_response);
        });
    }
    processGetArtistesViewModel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getInfosProjetViewModel(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/etapes/informationsProjet";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetInfosProjetViewModel(_response);
        });
    }
    processGetInfosProjetViewModel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getDescriptionProjetViewModel(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/description-projet/viewmodel";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDescriptionProjetViewModel(_response);
        });
    }
    processGetDescriptionProjetViewModel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class FormeJuridiqueClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateFormeJuridiqueCategorieMapping(body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/FormeJuridique/updateCategorie";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateFormeJuridiqueCategorieMapping(_response);
        });
    }
    processUpdateFormeJuridiqueCategorieMapping(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class GenerationSpedidamClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @param sortBy (optional)
     * @param sortDirection (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getGenerationsSpedidam(sortBy, sortDirection, page, pageSize, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/GenerationSpedidam?";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetGenerationsSpedidam(_response);
        });
    }
    processGetGenerationsSpedidam(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    createGenerationSpedidam(body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/GenerationSpedidam";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateGenerationSpedidam(_response);
        });
    }
    processCreateGenerationSpedidam(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve(result201);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getGenerationSpedidamCommissions(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/GenerationSpedidam/commissions";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetGenerationSpedidamCommissions(_response);
        });
    }
    processGetGenerationSpedidamCommissions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    deactivateGenerationSpedidam(id, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/GenerationSpedidam/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PUT",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeactivateGenerationSpedidam(_response);
        });
    }
    processDeactivateGenerationSpedidam(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    deleteGenerationSpedidam(id, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/GenerationSpedidam/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeleteGenerationSpedidam(_response);
        });
    }
    processDeleteGenerationSpedidam(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateGenerationSpedidam(id, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/GenerationSpedidam/{id}/edit";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateGenerationSpedidam(_response);
        });
    }
    processUpdateGenerationSpedidam(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class MessageAlerteClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @return Success
     */
    getMessageAlerte(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/MessageAlerte/message";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetMessageAlerte(_response);
        });
    }
    processGetMessageAlerte(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getAllMessageAlerte(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/MessageAlerte/messages";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetAllMessageAlerte(_response);
        });
    }
    processGetAllMessageAlerte(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class MessageAlerteBOClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateMessageAlerte(body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/MessageAlerteBO/message";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateOrUpdateMessageAlerte(_response);
        });
    }
    processCreateOrUpdateMessageAlerte(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve(result201);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    deleteMessageAlerte(id, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/MessageAlerteBO/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeleteMessageAlerte(_response);
        });
    }
    processDeleteMessageAlerte(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class ModeleMessageClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    createModeleMessage(body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/ModeleMessage";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateModeleMessage(_response);
        });
    }
    processCreateModeleMessage(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve(result201);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getModeleMessage(templateId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/ModeleMessage/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetModeleMessage(_response);
        });
    }
    processGetModeleMessage(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateModeleMessage(templateId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/ModeleMessage/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateModeleMessage(_response);
        });
    }
    processUpdateModeleMessage(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    deleteModeleMessage(templateId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/ModeleMessage/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeleteModeleMessage(_response);
        });
    }
    processDeleteModeleMessage(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getModelesMessage(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/ModeleMessage/list";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetModelesMessage(_response);
        });
    }
    processGetModelesMessage(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class PageVitrineClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @return Success
     */
    getPagesVitrine(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/PageVitrine";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetPagesVitrine(_response);
        });
    }
    processGetPagesVitrine(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    createPageVitrine(body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/PageVitrine";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreatePageVitrine(_response);
        });
    }
    processCreatePageVitrine(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve(result201);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updatePageVitrine(pageVitrineId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/PageVitrine/{pageVitrineId}";
        if (pageVitrineId === undefined || pageVitrineId === null)
            throw new Error("The parameter 'pageVitrineId' must be defined.");
        url_ = url_.replace("{pageVitrineId}", encodeURIComponent("" + pageVitrineId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdatePageVitrine(_response);
        });
    }
    processUpdatePageVitrine(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    deletePageVitrine(pageVitrineId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/PageVitrine/{pageVitrineId}";
        if (pageVitrineId === undefined || pageVitrineId === null)
            throw new Error("The parameter 'pageVitrineId' must be defined.");
        url_ = url_.replace("{pageVitrineId}", encodeURIComponent("" + pageVitrineId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeletePageVitrine(_response);
        });
    }
    processDeletePageVitrine(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    reorderPagesVitrine(body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/PageVitrine/reorder";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processReorderPagesVitrine(_response);
        });
    }
    processReorderPagesVitrine(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = resultData400;
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param file (optional)
     * @return Success
     */
    uploadPageVitrineFile(file, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/PageVitrine/uploadFile";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUploadPageVitrineFile(_response);
        });
    }
    processUploadPageVitrineFile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = resultData400;
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class PaysClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @return Success
     */
    getPays(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Pays";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetPays(_response);
        });
    }
    processGetPays(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class RelationClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @return Success
     */
    getRelation(relationId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Relation/{relationId}/get";
        if (relationId === undefined || relationId === null)
            throw new Error("The parameter 'relationId' must be defined.");
        url_ = url_.replace("{relationId}", encodeURIComponent("" + relationId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetRelation(_response);
        });
    }
    processGetRelation(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateRelation(relationId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Relation/{relationId}/update";
        if (relationId === undefined || relationId === null)
            throw new Error("The parameter 'relationId' must be defined.");
        url_ = url_.replace("{relationId}", encodeURIComponent("" + relationId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateRelation(_response);
        });
    }
    processUpdateRelation(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getDossierRelations(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Relation/dossier/{dossierId}";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDossierRelations(_response);
        });
    }
    processGetDossierRelations(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    createDossierRelation(dossierId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Relation/dossier/{dossierId}/create";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateDossierRelation(_response);
        });
    }
    processCreateDossierRelation(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getStructureRelations(structureId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Relation/structure/{structureId}";
        if (structureId === undefined || structureId === null)
            throw new Error("The parameter 'structureId' must be defined.");
        url_ = url_.replace("{structureId}", encodeURIComponent("" + structureId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetStructureRelations(_response);
        });
    }
    processGetStructureRelations(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    createStructureRelation(structureId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Relation/structure/{structureId}/create";
        if (structureId === undefined || structureId === null)
            throw new Error("The parameter 'structureId' must be defined.");
        url_ = url_.replace("{structureId}", encodeURIComponent("" + structureId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateStructureRelation(_response);
        });
    }
    processCreateStructureRelation(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    deleteRelation(relationId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Relation/{relationId}/delete";
        if (relationId === undefined || relationId === null)
            throw new Error("The parameter 'relationId' must be defined.");
        url_ = url_.replace("{relationId}", encodeURIComponent("" + relationId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeleteRelation(_response);
        });
    }
    processDeleteRelation(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class RemunerationClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @param categorieId (optional)
     * @param styleMusicalId (optional)
     * @param emploi (optional)
     * @param typePrestation (optional)
     * @param montantMinimum (optional)
     * @param montantMaximum (optional)
     * @param sortBy (optional)
     * @param sortDirection (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getRemunerations(categorieId, styleMusicalId, emploi, typePrestation, montantMinimum, montantMaximum, sortBy, sortDirection, page, pageSize, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Remuneration?";
        if (categorieId === null)
            throw new Error("The parameter 'categorieId' cannot be null.");
        else if (categorieId !== undefined)
            url_ += "CategorieId=" + encodeURIComponent("" + categorieId) + "&";
        if (styleMusicalId === null)
            throw new Error("The parameter 'styleMusicalId' cannot be null.");
        else if (styleMusicalId !== undefined)
            url_ += "StyleMusicalId=" + encodeURIComponent("" + styleMusicalId) + "&";
        if (emploi === null)
            throw new Error("The parameter 'emploi' cannot be null.");
        else if (emploi !== undefined)
            url_ += "Emploi=" + encodeURIComponent("" + emploi) + "&";
        if (typePrestation === null)
            throw new Error("The parameter 'typePrestation' cannot be null.");
        else if (typePrestation !== undefined)
            url_ += "TypePrestation=" + encodeURIComponent("" + typePrestation) + "&";
        if (montantMinimum === null)
            throw new Error("The parameter 'montantMinimum' cannot be null.");
        else if (montantMinimum !== undefined)
            url_ += "MontantMinimum=" + encodeURIComponent("" + montantMinimum) + "&";
        if (montantMaximum === null)
            throw new Error("The parameter 'montantMaximum' cannot be null.");
        else if (montantMaximum !== undefined)
            url_ += "MontantMaximum=" + encodeURIComponent("" + montantMaximum) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetRemunerations(_response);
        });
    }
    processGetRemunerations(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    createRemuneration(body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Remuneration";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateRemuneration(_response);
        });
    }
    processCreateRemuneration(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve(result201);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getRemunerationsViewModel(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Remuneration/viewmodel";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetRemunerationsViewModel(_response);
        });
    }
    processGetRemunerationsViewModel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    deleteRemuneration(id, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Remuneration/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeleteRemuneration(_response);
        });
    }
    processDeleteRemuneration(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getStylesMusicaux(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Remuneration/stylesMusicaux";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetStylesMusicaux(_response);
        });
    }
    processGetStylesMusicaux(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class RoleClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @return Success
     */
    getRoles(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Role";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetRoles(_response);
        });
    }
    processGetRoles(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getRoleAccess(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Role/model";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetRoleAccess(_response);
        });
    }
    processGetRoleAccess(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class StructureClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @param filters (optional)
     * @param sorts (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param disablePagination (optional)
     * @return Success
     */
    getStructures(filters, sorts, page, pageSize, disablePagination, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure?";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&";
        if (sorts === null)
            throw new Error("The parameter 'sorts' cannot be null.");
        else if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (disablePagination === null)
            throw new Error("The parameter 'disablePagination' cannot be null.");
        else if (disablePagination !== undefined)
            url_ += "DisablePagination=" + encodeURIComponent("" + disablePagination) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetStructures(_response);
        });
    }
    processGetStructures(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getStructureDetails(structureId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/{structureId}/details";
        if (structureId === undefined || structureId === null)
            throw new Error("The parameter 'structureId' must be defined.");
        url_ = url_.replace("{structureId}", encodeURIComponent("" + structureId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetStructureDetails(_response);
        });
    }
    processGetStructureDetails(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param representantLegalEmail (optional)
     * @param adresseCorrespondance_Line1 (optional)
     * @param adresseCorrespondance_Line2 (optional)
     * @param adresseCorrespondance_CodePostal (optional)
     * @param adresseCorrespondance_Ville (optional)
     * @param documents (optional)
     * @param files (optional)
     * @return Success
     */
    updateStructureDetails(structureId, representantLegalEmail, adresseCorrespondance_Line1, adresseCorrespondance_Line2, adresseCorrespondance_CodePostal, adresseCorrespondance_Ville, documents, files, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/{structureId}/details";
        if (structureId === undefined || structureId === null)
            throw new Error("The parameter 'structureId' must be defined.");
        url_ = url_.replace("{structureId}", encodeURIComponent("" + structureId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (representantLegalEmail === null || representantLegalEmail === undefined)
            throw new Error("The parameter 'representantLegalEmail' cannot be null.");
        else
            content_.append("RepresentantLegalEmail", representantLegalEmail.toString());
        if (adresseCorrespondance_Line1 === null || adresseCorrespondance_Line1 === undefined)
            throw new Error("The parameter 'adresseCorrespondance_Line1' cannot be null.");
        else
            content_.append("AdresseCorrespondance.Line1", adresseCorrespondance_Line1.toString());
        if (adresseCorrespondance_Line2 === null || adresseCorrespondance_Line2 === undefined)
            throw new Error("The parameter 'adresseCorrespondance_Line2' cannot be null.");
        else
            content_.append("AdresseCorrespondance.Line2", adresseCorrespondance_Line2.toString());
        if (adresseCorrespondance_CodePostal === null || adresseCorrespondance_CodePostal === undefined)
            throw new Error("The parameter 'adresseCorrespondance_CodePostal' cannot be null.");
        else
            content_.append("AdresseCorrespondance.CodePostal", adresseCorrespondance_CodePostal.toString());
        if (adresseCorrespondance_Ville === null || adresseCorrespondance_Ville === undefined)
            throw new Error("The parameter 'adresseCorrespondance_Ville' cannot be null.");
        else
            content_.append("AdresseCorrespondance.Ville", adresseCorrespondance_Ville.toString());
        if (documents === null || documents === undefined)
            throw new Error("The parameter 'documents' cannot be null.");
        else
            documents.forEach(item_ => content_.append("Documents", item_.toString()));
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files"));
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateStructureDetails(_response);
        });
    }
    processUpdateStructureDetails(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getStructureInstruction(structureId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/{structureId}/instruction";
        if (structureId === undefined || structureId === null)
            throw new Error("The parameter 'structureId' must be defined.");
        url_ = url_.replace("{structureId}", encodeURIComponent("" + structureId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetStructureInstruction(_response);
        });
    }
    processGetStructureInstruction(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param statut (optional)
     * @param categoriesDossierSelectionnees (optional)
     * @param documents (optional)
     * @param files (optional)
     * @return Success
     */
    updateStructureInstruction(structureId, statut, categoriesDossierSelectionnees, documents, files, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/{structureId}/instruction";
        if (structureId === undefined || structureId === null)
            throw new Error("The parameter 'structureId' must be defined.");
        url_ = url_.replace("{structureId}", encodeURIComponent("" + structureId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (statut === null || statut === undefined)
            throw new Error("The parameter 'statut' cannot be null.");
        else
            content_.append("Statut", statut.toString());
        if (categoriesDossierSelectionnees === null || categoriesDossierSelectionnees === undefined)
            throw new Error("The parameter 'categoriesDossierSelectionnees' cannot be null.");
        else
            categoriesDossierSelectionnees.forEach(item_ => content_.append("CategoriesDossierSelectionnees", item_.toString()));
        if (documents === null || documents === undefined)
            throw new Error("The parameter 'documents' cannot be null.");
        else
            documents.forEach(item_ => content_.append("Documents", item_.toString()));
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files"));
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateStructureInstruction(_response);
        });
    }
    processUpdateStructureInstruction(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = resultData400;
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getStructureDocuments(structureId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/{structureId}/documentsComplementaire";
        if (structureId === undefined || structureId === null)
            throw new Error("The parameter 'structureId' must be defined.");
        url_ = url_.replace("{structureId}", encodeURIComponent("" + structureId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetStructureDocuments(_response);
        });
    }
    processGetStructureDocuments(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param documents (optional)
     * @param files (optional)
     * @return Success
     */
    updateStructureDocuments(structureId, documents, files, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/{structureId}/documentsComplementaire";
        if (structureId === undefined || structureId === null)
            throw new Error("The parameter 'structureId' must be defined.");
        url_ = url_.replace("{structureId}", encodeURIComponent("" + structureId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (documents === null || documents === undefined)
            throw new Error("The parameter 'documents' cannot be null.");
        else
            documents.forEach(item_ => content_.append("Documents", item_.toString()));
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files"));
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateStructureDocuments(_response);
        });
    }
    processUpdateStructureDocuments(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = resultData400;
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param iban (optional)
     * @param bic (optional)
     * @param banque (optional)
     * @param adresse_Line1 (optional)
     * @param adresse_Line2 (optional)
     * @param adresse_CodePostal (optional)
     * @param adresse_Ville (optional)
     * @param rIB_Id (optional)
     * @param rIB_TypeId (optional)
     * @param rIB_PartName (optional)
     * @param rIB_actionType (optional)
     * @param rIB_ExtraInfos (optional)
     * @param rIB_FileName (optional)
     * @param rIB_ContentType (optional)
     * @param rIB_Content_CanRead (optional)
     * @param rIB_Content_CanWrite (optional)
     * @param rIB_Content_CanSeek (optional)
     * @param rIB_Content_CanTimeout (optional)
     * @param rIB_Content_Length (optional)
     * @param rIB_Content_Position (optional)
     * @param rIB_Content_ReadTimeout (optional)
     * @param rIB_Content_WriteTimeout (optional)
     * @param files (optional)
     * @return Success
     */
    createOrUpdateDonneesBancaires(structureId, iban, bic, banque, adresse_Line1, adresse_Line2, adresse_CodePostal, adresse_Ville, rIB_Id, rIB_TypeId, rIB_PartName, rIB_actionType, rIB_ExtraInfos, rIB_FileName, rIB_ContentType, rIB_Content_CanRead, rIB_Content_CanWrite, rIB_Content_CanSeek, rIB_Content_CanTimeout, rIB_Content_Length, rIB_Content_Position, rIB_Content_ReadTimeout, rIB_Content_WriteTimeout, files, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/{structureId}/donneesBancaires";
        if (structureId === undefined || structureId === null)
            throw new Error("The parameter 'structureId' must be defined.");
        url_ = url_.replace("{structureId}", encodeURIComponent("" + structureId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (iban === null || iban === undefined)
            throw new Error("The parameter 'iban' cannot be null.");
        else
            content_.append("Iban", iban.toString());
        if (bic === null || bic === undefined)
            throw new Error("The parameter 'bic' cannot be null.");
        else
            content_.append("Bic", bic.toString());
        if (banque === null || banque === undefined)
            throw new Error("The parameter 'banque' cannot be null.");
        else
            content_.append("Banque", banque.toString());
        if (adresse_Line1 === null || adresse_Line1 === undefined)
            throw new Error("The parameter 'adresse_Line1' cannot be null.");
        else
            content_.append("Adresse.Line1", adresse_Line1.toString());
        if (adresse_Line2 === null || adresse_Line2 === undefined)
            throw new Error("The parameter 'adresse_Line2' cannot be null.");
        else
            content_.append("Adresse.Line2", adresse_Line2.toString());
        if (adresse_CodePostal === null || adresse_CodePostal === undefined)
            throw new Error("The parameter 'adresse_CodePostal' cannot be null.");
        else
            content_.append("Adresse.CodePostal", adresse_CodePostal.toString());
        if (adresse_Ville === null || adresse_Ville === undefined)
            throw new Error("The parameter 'adresse_Ville' cannot be null.");
        else
            content_.append("Adresse.Ville", adresse_Ville.toString());
        if (rIB_Id === null || rIB_Id === undefined)
            throw new Error("The parameter 'rIB_Id' cannot be null.");
        else
            content_.append("RIB.Id", rIB_Id.toString());
        if (rIB_TypeId === null || rIB_TypeId === undefined)
            throw new Error("The parameter 'rIB_TypeId' cannot be null.");
        else
            content_.append("RIB.TypeId", rIB_TypeId.toString());
        if (rIB_PartName === null || rIB_PartName === undefined)
            throw new Error("The parameter 'rIB_PartName' cannot be null.");
        else
            content_.append("RIB.PartName", rIB_PartName.toString());
        if (rIB_actionType === null || rIB_actionType === undefined)
            throw new Error("The parameter 'rIB_actionType' cannot be null.");
        else
            content_.append("RIB.actionType", rIB_actionType.toString());
        if (rIB_ExtraInfos === null || rIB_ExtraInfos === undefined)
            throw new Error("The parameter 'rIB_ExtraInfos' cannot be null.");
        else
            content_.append("RIB.ExtraInfos", JSON.stringify(rIB_ExtraInfos));
        if (rIB_FileName === null || rIB_FileName === undefined)
            throw new Error("The parameter 'rIB_FileName' cannot be null.");
        else
            content_.append("RIB.FileName", rIB_FileName.toString());
        if (rIB_ContentType === null || rIB_ContentType === undefined)
            throw new Error("The parameter 'rIB_ContentType' cannot be null.");
        else
            content_.append("RIB.ContentType", rIB_ContentType.toString());
        if (rIB_Content_CanRead === null || rIB_Content_CanRead === undefined)
            throw new Error("The parameter 'rIB_Content_CanRead' cannot be null.");
        else
            content_.append("RIB.Content.CanRead", rIB_Content_CanRead.toString());
        if (rIB_Content_CanWrite === null || rIB_Content_CanWrite === undefined)
            throw new Error("The parameter 'rIB_Content_CanWrite' cannot be null.");
        else
            content_.append("RIB.Content.CanWrite", rIB_Content_CanWrite.toString());
        if (rIB_Content_CanSeek === null || rIB_Content_CanSeek === undefined)
            throw new Error("The parameter 'rIB_Content_CanSeek' cannot be null.");
        else
            content_.append("RIB.Content.CanSeek", rIB_Content_CanSeek.toString());
        if (rIB_Content_CanTimeout === null || rIB_Content_CanTimeout === undefined)
            throw new Error("The parameter 'rIB_Content_CanTimeout' cannot be null.");
        else
            content_.append("RIB.Content.CanTimeout", rIB_Content_CanTimeout.toString());
        if (rIB_Content_Length === null || rIB_Content_Length === undefined)
            throw new Error("The parameter 'rIB_Content_Length' cannot be null.");
        else
            content_.append("RIB.Content.Length", rIB_Content_Length.toString());
        if (rIB_Content_Position === null || rIB_Content_Position === undefined)
            throw new Error("The parameter 'rIB_Content_Position' cannot be null.");
        else
            content_.append("RIB.Content.Position", rIB_Content_Position.toString());
        if (rIB_Content_ReadTimeout === null || rIB_Content_ReadTimeout === undefined)
            throw new Error("The parameter 'rIB_Content_ReadTimeout' cannot be null.");
        else
            content_.append("RIB.Content.ReadTimeout", rIB_Content_ReadTimeout.toString());
        if (rIB_Content_WriteTimeout === null || rIB_Content_WriteTimeout === undefined)
            throw new Error("The parameter 'rIB_Content_WriteTimeout' cannot be null.");
        else
            content_.append("RIB.Content.WriteTimeout", rIB_Content_WriteTimeout.toString());
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files"));
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateOrUpdateDonneesBancaires(_response);
        });
    }
    processCreateOrUpdateDonneesBancaires(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getStructureNote(structureId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/{structureId}/note";
        if (structureId === undefined || structureId === null)
            throw new Error("The parameter 'structureId' must be defined.");
        url_ = url_.replace("{structureId}", encodeURIComponent("" + structureId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetStructureNote(_response);
        });
    }
    processGetStructureNote(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateStructureNote(structureId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/{structureId}/note";
        if (structureId === undefined || structureId === null)
            throw new Error("The parameter 'structureId' must be defined.");
        url_ = url_.replace("{structureId}", encodeURIComponent("" + structureId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateStructureNote(_response);
        });
    }
    processUpdateStructureNote(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateStructureNotePro(structureId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/{structureId}/notePro";
        if (structureId === undefined || structureId === null)
            throw new Error("The parameter 'structureId' must be defined.");
        url_ = url_.replace("{structureId}", encodeURIComponent("" + structureId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateStructureNotePro(_response);
        });
    }
    processUpdateStructureNotePro(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param search (optional)
     * @return Success
     */
    autocompleteStructureName(search, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/autocomplete/structureName?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAutocompleteStructureName(_response);
        });
    }
    processAutocompleteStructureName(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param search (optional)
     * @return Success
     */
    autocompleteResponsableEmail(search, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/autocomplete/responsableEmail?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAutocompleteResponsableEmail(_response);
        });
    }
    processAutocompleteResponsableEmail(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param search (optional)
     * @return Success
     */
    autocompleteUsername(search, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/autocomplete/username?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAutocompleteUsername(_response);
        });
    }
    processAutocompleteUsername(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param search (optional)
     * @return Success
     */
    autocompleteResponsableName(search, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/autocomplete/responsableName?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAutocompleteResponsableName(_response);
        });
    }
    processAutocompleteResponsableName(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getDocuments(structureId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/{structureId}/documents";
        if (structureId === undefined || structureId === null)
            throw new Error("The parameter 'structureId' must be defined.");
        url_ = url_.replace("{structureId}", encodeURIComponent("" + structureId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDocuments(_response);
        });
    }
    processGetDocuments(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateStructureDocumentsValidation(structureId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/{structureId}/documents/validation";
        if (structureId === undefined || structureId === null)
            throw new Error("The parameter 'structureId' must be defined.");
        url_ = url_.replace("{structureId}", encodeURIComponent("" + structureId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateStructureDocumentsValidation(_response);
        });
    }
    processUpdateStructureDocumentsValidation(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param filters (optional)
     * @param sorts (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param disablePagination (optional)
     * @return Success
     */
    getStructureHistory(filters, sorts, page, pageSize, disablePagination, structureId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/{structureId}/history?";
        if (structureId === undefined || structureId === null)
            throw new Error("The parameter 'structureId' must be defined.");
        url_ = url_.replace("{structureId}", encodeURIComponent("" + structureId));
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&";
        if (sorts === null)
            throw new Error("The parameter 'sorts' cannot be null.");
        else if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (disablePagination === null)
            throw new Error("The parameter 'disablePagination' cannot be null.");
        else if (disablePagination !== undefined)
            url_ += "DisablePagination=" + encodeURIComponent("" + disablePagination) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetStructureHistory(_response);
        });
    }
    processGetStructureHistory(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getStructureBalance(structureId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/{structureId}/balance";
        if (structureId === undefined || structureId === null)
            throw new Error("The parameter 'structureId' must be defined.");
        url_ = url_.replace("{structureId}", encodeURIComponent("" + structureId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetStructureBalance(_response);
        });
    }
    processGetStructureBalance(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getDoublonsStructure(structureId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/{structureId}/doublons";
        if (structureId === undefined || structureId === null)
            throw new Error("The parameter 'structureId' must be defined.");
        url_ = url_.replace("{structureId}", encodeURIComponent("" + structureId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDoublonsStructure(_response);
        });
    }
    processGetDoublonsStructure(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateRIBValidation(structureId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/{structureId}/rib/validation";
        if (structureId === undefined || structureId === null)
            throw new Error("The parameter 'structureId' must be defined.");
        url_ = url_.replace("{structureId}", encodeURIComponent("" + structureId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateRIBValidation(_response);
        });
    }
    processUpdateRIBValidation(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class TemplateClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateTemplate(templateId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Template/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateTemplate(_response);
        });
    }
    processUpdateTemplate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param code (optional)
     * @return Success
     */
    getTemplateByCode(code, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Template?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetTemplateByCode(_response);
        });
    }
    processGetTemplateByCode(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class TypeDeDocumentClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @return Success
     */
    getTypesDeDocument(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/TypeDeDocument";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetTypesDeDocument(_response);
        });
    }
    processGetTypesDeDocument(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    createTypeDeDocument(body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/TypeDeDocument";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateTypeDeDocument(_response);
        });
    }
    processCreateTypeDeDocument(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve(result201);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateTypeDeDocument(id, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/TypeDeDocument/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateTypeDeDocument(_response);
        });
    }
    processUpdateTypeDeDocument(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    deleteTypeDeDocument(id, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/TypeDeDocument/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeleteTypeDeDocument(_response);
        });
    }
    processDeleteTypeDeDocument(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class UserClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @return Success
     */
    getMe(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/User/me";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetMe(_response);
        });
    }
    processGetMe(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param roles (optional)
     * @param search (optional)
     * @param actifs (optional)
     * @return Success
     */
    getUsers(roles, search, actifs, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/User?";
        if (roles === null)
            throw new Error("The parameter 'roles' cannot be null.");
        else if (roles !== undefined)
            roles && roles.forEach(item => { url_ += "roles=" + encodeURIComponent("" + item) + "&"; });
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (actifs === null)
            throw new Error("The parameter 'actifs' cannot be null.");
        else if (actifs !== undefined)
            url_ += "actifs=" + encodeURIComponent("" + actifs) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetUsers(_response);
        });
    }
    processGetUsers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    createUser(body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/User";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateUser(_response);
        });
    }
    processCreateUser(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateUser(userId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/User/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateUser(_response);
        });
    }
    processUpdateUser(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getActionPermissions(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/User/permissions";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetActionPermissions(_response);
        });
    }
    processGetActionPermissions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class ValidationClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @return Success
     */
    getValidationDescriptors(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Validation";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetValidationDescriptors(_response);
        });
    }
    processGetValidationDescriptors(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class VersementClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @return Success
     */
    getVersementDetails(versementId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/{versementId}/details";
        if (versementId === undefined || versementId === null)
            throw new Error("The parameter 'versementId' must be defined.");
        url_ = url_.replace("{versementId}", encodeURIComponent("" + versementId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetVersementDetails(_response);
        });
    }
    processGetVersementDetails(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateDSVInstructionVersement(versementId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/{versementId}/dsvinstruction/update";
        if (versementId === undefined || versementId === null)
            throw new Error("The parameter 'versementId' must be defined.");
        url_ = url_.replace("{versementId}", encodeURIComponent("" + versementId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateDSVInstructionVersement(_response);
        });
    }
    processUpdateDSVInstructionVersement(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    createVersementArtiste(versementId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/artiste/{versementId}";
        if (versementId === undefined || versementId === null)
            throw new Error("The parameter 'versementId' must be defined.");
        url_ = url_.replace("{versementId}", encodeURIComponent("" + versementId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateVersementArtiste(_response);
        });
    }
    processCreateVersementArtiste(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve(result201);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateVersementArtiste(versementArtisteId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/artiste/{versementArtisteId}";
        if (versementArtisteId === undefined || versementArtisteId === null)
            throw new Error("The parameter 'versementArtisteId' must be defined.");
        url_ = url_.replace("{versementArtisteId}", encodeURIComponent("" + versementArtisteId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateVersementArtiste(_response);
        });
    }
    processUpdateVersementArtiste(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    deleteVersementArtiste(versementArtisteId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/artiste/{versementArtisteId}";
        if (versementArtisteId === undefined || versementArtisteId === null)
            throw new Error("The parameter 'versementArtisteId' must be defined.");
        url_ = url_.replace("{versementArtisteId}", encodeURIComponent("" + versementArtisteId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeleteVersementArtiste(_response);
        });
    }
    processDeleteVersementArtiste(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateStatutDemandeVersement(versementId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/{versementId}/statut";
        if (versementId === undefined || versementId === null)
            throw new Error("The parameter 'versementId' must be defined.");
        url_ = url_.replace("{versementId}", encodeURIComponent("" + versementId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateStatutDemandeVersement(_response);
        });
    }
    processUpdateStatutDemandeVersement(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param versementArtistes (optional)
     * @param enseignants (optional)
     * @param documents (optional)
     * @return Success
     */
    updateArtisteDocument(versementId, versementArtistes, enseignants, documents, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/{versementId}/contratscachets/artiste/document";
        if (versementId === undefined || versementId === null)
            throw new Error("The parameter 'versementId' must be defined.");
        url_ = url_.replace("{versementId}", encodeURIComponent("" + versementId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (versementArtistes === null || versementArtistes === undefined)
            throw new Error("The parameter 'versementArtistes' cannot be null.");
        else
            versementArtistes.forEach(item_ => content_.append("VersementArtistes", item_.toString()));
        if (enseignants === null || enseignants === undefined)
            throw new Error("The parameter 'enseignants' cannot be null.");
        else
            enseignants.forEach(item_ => content_.append("Enseignants", item_.toString()));
        if (documents === null || documents === undefined)
            throw new Error("The parameter 'documents' cannot be null.");
        else
            documents.forEach(item_ => content_.append("documents", item_.data, item_.fileName ? item_.fileName : "documents"));
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateArtisteDocument(_response);
        });
    }
    processUpdateArtisteDocument(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateVersementArtistesValidation(versementId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/{versementId}/artistes/validation";
        if (versementId === undefined || versementId === null)
            throw new Error("The parameter 'versementId' must be defined.");
        url_ = url_.replace("{versementId}", encodeURIComponent("" + versementId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateVersementArtistesValidation(_response);
        });
    }
    processUpdateVersementArtistesValidation(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateVersementDepensesValidation(versementId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/{versementId}/depenses/validation";
        if (versementId === undefined || versementId === null)
            throw new Error("The parameter 'versementId' must be defined.");
        url_ = url_.replace("{versementId}", encodeURIComponent("" + versementId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateVersementDepensesValidation(_response);
        });
    }
    processUpdateVersementDepensesValidation(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateVersementDocumentsValidation(versementId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/{versementId}/documents/validation";
        if (versementId === undefined || versementId === null)
            throw new Error("The parameter 'versementId' must be defined.");
        url_ = url_.replace("{versementId}", encodeURIComponent("" + versementId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateVersementDocumentsValidation(_response);
        });
    }
    processUpdateVersementDocumentsValidation(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getRecalculMasseSalariale(versementId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/{versementId}/recalculate";
        if (versementId === undefined || versementId === null)
            throw new Error("The parameter 'versementId' must be defined.");
        url_ = url_.replace("{versementId}", encodeURIComponent("" + versementId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetRecalculMasseSalariale(_response);
        });
    }
    processGetRecalculMasseSalariale(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getDemandeVersementMasseSalariale(versementId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/{versementId}/massesalariale";
        if (versementId === undefined || versementId === null)
            throw new Error("The parameter 'versementId' must be defined.");
        url_ = url_.replace("{versementId}", encodeURIComponent("" + versementId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDemandeVersementMasseSalariale(_response);
        });
    }
    processGetDemandeVersementMasseSalariale(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class VueClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @param type (optional)
     * @return Success
     */
    getVues(type, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Vue?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetVues(_response);
        });
    }
    processGetVues(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    createVue(body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Vue";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateVue(_response);
        });
    }
    processCreateVue(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve(result201);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateVue(vueId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Vue/{vueId}";
        if (vueId === undefined || vueId === null)
            throw new Error("The parameter 'vueId' must be defined.");
        url_ = url_.replace("{vueId}", encodeURIComponent("" + vueId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateVue(_response);
        });
    }
    processUpdateVue(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    deleteVue(vueId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Vue/{vueId}";
        if (vueId === undefined || vueId === null)
            throw new Error("The parameter 'vueId' must be defined.");
        url_ = url_.replace("{vueId}", encodeURIComponent("" + vueId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeleteVue(_response);
        });
    }
    processDeleteVue(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export var AnswerType;
(function (AnswerType) {
    AnswerType["None"] = "none";
    AnswerType["Text"] = "text";
    AnswerType["MultilineText"] = "multilineText";
    AnswerType["Date"] = "date";
    AnswerType["IntegerNumber"] = "integerNumber";
    AnswerType["DecimalNumber"] = "decimalNumber";
    AnswerType["SingleChoiceList"] = "singleChoiceList";
    AnswerType["MultipleChoiceList"] = "multipleChoiceList";
    AnswerType["YesNo"] = "yesNo";
    AnswerType["YesNoDontKnow"] = "yesNoDontKnow";
    AnswerType["File"] = "file";
    AnswerType["Url"] = "url";
    AnswerType["Link"] = "link";
    AnswerType["Period"] = "period";
    AnswerType["Html"] = "html";
    AnswerType["Array"] = "array";
    AnswerType["Blocking"] = "blocking";
})(AnswerType || (AnswerType = {}));
export var ChampDepense;
(function (ChampDepense) {
    ChampDepense["None"] = "none";
    ChampDepense["Autre"] = "autre";
    ChampDepense["SalairesArtisteEnregistrement"] = "salairesArtisteEnregistrement";
    ChampDepense["SalairesArtisteRepetition"] = "salairesArtisteRepetition";
    ChampDepense["SalairesArtisteRepresentation"] = "salairesArtisteRepresentation";
    ChampDepense["SalairesArtisteMensualisation"] = "salairesArtisteMensualisation";
    ChampDepense["ChargesSocialesPatronalesArtistes"] = "chargesSocialesPatronalesArtistes";
    ChampDepense["AutresSalairesArtistiquesChargesSocialesPatronalesIncluses"] = "autresSalairesArtistiquesChargesSocialesPatronalesIncluses";
    ChampDepense["SalairesTechniciensChargesSocialesPatronalesIncluses"] = "salairesTechniciensChargesSocialesPatronalesIncluses";
    ChampDepense["SalairesPersonnelsAdministratifsChargesSocialesPatronalesIncluses"] = "salairesPersonnelsAdministratifsChargesSocialesPatronalesIncluses";
    ChampDepense["LocationSalle"] = "locationSalle";
    ChampDepense["Assurances"] = "assurances";
    ChampDepense["Defraiements"] = "defraiements";
    ChampDepense["PublicitePromotion"] = "publicitePromotion";
    ChampDepense["Organisme"] = "organisme";
    ChampDepense["Musiciens"] = "musiciens";
    ChampDepense["Danseurs"] = "danseurs";
    ChampDepense["Choristes"] = "choristes";
    ChampDepense["Chanteurs"] = "chanteurs";
    ChampDepense["Comediens"] = "comediens";
    ChampDepense["ChefsOrchestre"] = "chefsOrchestre";
    ChampDepense["ChargesPatronales"] = "chargesPatronales";
    ChampDepense["CongesSpectales"] = "congesSpectales";
    ChampDepense["Auteurs"] = "auteurs";
    ChampDepense["MetteursEnScene"] = "metteursEnScene";
    ChampDepense["Choregraphes"] = "choregraphes";
    ChampDepense["DecorateursCostumiers"] = "decorateursCostumiers";
    ChampDepense["CommandesMusicales"] = "commandesMusicales";
    ChampDepense["Agessa"] = "agessa";
    ChampDepense["AdministrationCoordination"] = "administrationCoordination";
    ChampDepense["TelephoneFaxEnvois"] = "telephoneFaxEnvois";
    ChampDepense["TechniciensIngenieurs"] = "techniciensIngenieurs";
    ChampDepense["Divers"] = "divers";
    ChampDepense["CommunicationPublicite"] = "communicationPublicite";
    ChampDepense["AttacheDePresse"] = "attacheDePresse";
    ChampDepense["FraisDeFonctionnementLocation"] = "fraisDeFonctionnementLocation";
    ChampDepense["MasseSalarialeArtistiqueEstimeeContratsVente"] = "masseSalarialeArtistiqueEstimeeContratsVente";
    ChampDepense["ContratsVentes"] = "contratsVentes";
    ChampDepense["BilletsAvion"] = "billetsAvion";
    ChampDepense["BilletsTrain"] = "billetsTrain";
    ChampDepense["LocationVoiture"] = "locationVoiture";
    ChampDepense["Hotel"] = "hotel";
    ChampDepense["Restauration"] = "restauration";
    ChampDepense["Carburant"] = "carburant";
    ChampDepense["TransportInstruments"] = "transportInstruments";
    ChampDepense["Hebergement"] = "hebergement";
    ChampDepense["CotisationAFC"] = "cotisationAFC";
    ChampDepense["SalaireArtistes"] = "salaireArtistes";
    ChampDepense["RealisationEtImpressionInvitations"] = "realisationEtImpressionInvitations";
    ChampDepense["EnvoisEtInsertionsPresse"] = "envoisEtInsertionsPresse";
    ChampDepense["Deplacements"] = "deplacements";
    ChampDepense["FraisOrganisation"] = "fraisOrganisation";
    ChampDepense["Sacem"] = "sacem";
    ChampDepense["Arrangeur"] = "arrangeur";
    ChampDepense["LocationStudio"] = "locationStudio";
    ChampDepense["LocationMateriel"] = "locationMateriel";
    ChampDepense["SalairesEnseignantsPermanents"] = "salairesEnseignantsPermanents";
    ChampDepense["ChargesSocialesEnseignantsPermanents"] = "chargesSocialesEnseignantsPermanents";
    ChampDepense["SalairesEnseignantsVacataires"] = "salairesEnseignantsVacataires";
    ChampDepense["ChargesSocialesEnseignantsVacataires"] = "chargesSocialesEnseignantsVacataires";
    ChampDepense["Loyers"] = "loyers";
    ChampDepense["FraisFonctionnement"] = "fraisFonctionnement";
    ChampDepense["Cotisations"] = "cotisations";
    ChampDepense["FraisBancaires"] = "fraisBancaires";
    ChampDepense["TaxesSalaires"] = "taxesSalaires";
    ChampDepense["FormationProfessionnelleContinue"] = "formationProfessionnelleContinue";
    ChampDepense["TaxeApprentissage"] = "taxeApprentissage";
    ChampDepense["DevisRealisation"] = "devisRealisation";
    ChampDepense["DroitsPourUtilisationsSecondaires"] = "droitsPourUtilisationsSecondaires";
    ChampDepense["DroitsSurDocumentsArchives"] = "droitsSurDocumentsArchives";
    ChampDepense["DroitsPhotographiques"] = "droitsPhotographiques";
    ChampDepense["DroitsAuteur"] = "droitsAuteur";
    ChampDepense["BandesEtFournitures"] = "bandesEtFournitures";
    ChampDepense["SalaireVerseSuiteAnnulations"] = "salaireVerseSuiteAnnulations";
    ChampDepense["IndemniteVerseSuiteAnnulations"] = "indemniteVerseSuiteAnnulations";
    ChampDepense["PrestationTechnique"] = "prestationTechnique";
    ChampDepense["Copiste"] = "copiste";
    ChampDepense["SalairesPersonnelsAdministratifs"] = "salairesPersonnelsAdministratifs";
    ChampDepense["ChargesSocialesPersonnelsAdministratifs"] = "chargesSocialesPersonnelsAdministratifs";
    ChampDepense["AutresSalairesChargesSocialesIncluses"] = "autresSalairesChargesSocialesIncluses";
    ChampDepense["SalairesArtisteConcert"] = "salairesArtisteConcert";
    ChampDepense["SalairesArtisteEngagementDirect"] = "SalairesArtisteEngagementDirect";
    ChampDepense["CotisationPatronalesEngagementDirect"] = "CotisationPatronalesEngagementDirect";
    ChampDepense["SalairesArtisteContratVente"] = "SalairesArtisteContratVente";
    ChampDepense["CotisationPatronalesContratVente"] = "CotisationPatronalesContratVente";
    ChampDepense["CessionTTC"] = "CessionTTC";
    ChampDepense["VoyagesAI"] = "VoyagesAI";
    ChampDepense["TransportMateriel"] = "TransportMateriel";
    ChampDepense["VoyagesTechnicienPersonnelAdministratif"] = "VoyagesTechnicienPersonnelAdministratif";
    ChampDepense["RepasEquipe"] = "RepasEquipe";
    ChampDepense["HebergementEquipe"] = "HebergementEquipe";
    ChampDepense["SalairesTechniciensIntermittents"] = "SalairesTechniciensIntermittents";
    ChampDepense["AutresFraisTechniques"] = "AutresFraisTechniques";
    ChampDepense["DroitsAuteurs"] = "DroitsAuteurs";
    ChampDepense["AutresFrais"] = "AutresFrais";
})(ChampDepense || (ChampDepense = {}));
export var ChampFinancement;
(function (ChampFinancement) {
    ChampFinancement["None"] = "none";
    ChampFinancement["Autre"] = "autre";
    ChampFinancement["VenteTotaleBillets"] = "venteTotaleBillets";
    ChampFinancement["VenteTiers"] = "venteTiers";
    ChampFinancement["RecettesAnnexes"] = "recettesAnnexes";
    ChampFinancement["ContrepartiesEnServicesOuCoProduction"] = "contrepartiesEnServicesOuCoProduction";
    ChampFinancement["ApportsPersonnelsGarantis"] = "apportsPersonnelsGarantis";
    ChampFinancement["ApportsPersonnelsGarantisFortissimo"] = "apportsPersonnelsGarantisFortissimo";
    ChampFinancement["FondsEuropeens"] = "fondsEuropeens";
    ChampFinancement["MinistereDeLaCulture"] = "ministereDeLaCulture";
    ChampFinancement["Drac"] = "drac";
    ChampFinancement["ConseilRegional"] = "conseilRegional";
    ChampFinancement["ConseilGeneral"] = "conseilGeneral";
    ChampFinancement["CommunauteDeCommunes"] = "communauteDeCommunes";
    ChampFinancement["Municipalite"] = "municipalite";
    ChampFinancement["Cnm"] = "cnm";
    ChampFinancement["SacemOuAssociationBeaumarchais"] = "sacemOuAssociationBeaumarchais";
    ChampFinancement["Sacd"] = "sacd";
    ChampFinancement["ScpPouSPPF"] = "scpPouSPPF";
    ChampFinancement["Adami"] = "adami";
    ChampFinancement["MontantDemandeSPEDIDAM"] = "montantDemandeSPEDIDAM";
    ChampFinancement["VenteSpectacles"] = "venteSpectacles";
    ChampFinancement["VenteBilletsEscompte"] = "venteBilletsEscompte";
    ChampFinancement["ContrePartiesEnServices"] = "contrePartiesEnServices";
    ChampFinancement["CoProduction"] = "coProduction";
    ChampFinancement["Divers"] = "divers";
    ChampFinancement["Sacem"] = "sacem";
    ChampFinancement["Fcm"] = "fcm";
    ChampFinancement["FinancementParticipatifOuCampagneCrowdfunding"] = "financementParticipatifOuCampagneCrowdfunding";
    ChampFinancement["FondSoutienProfessionnalisationAFC"] = "fondSoutienProfessionnalisationAFC";
    ChampFinancement["AutresPartenaires"] = "autresPartenaires";
    ChampFinancement["Vente"] = "vente";
    ChampFinancement["ConseilDepartemental"] = "conseilDepartemental";
    ChampFinancement["Cnc"] = "cnc";
    ChampFinancement["Cours"] = "cours";
    ChampFinancement["Adhesions"] = "adhesions";
    ChampFinancement["AfdasCifCnfpt"] = "afdasCifCnfpt";
    ChampFinancement["AutresRecettesExploitation"] = "autresRecettesExploitation";
    ChampFinancement["Ville"] = "ville";
    ChampFinancement["ApportFondsPropres"] = "apportFondsPropres";
    ChampFinancement["ApportProducteur"] = "apportProducteur";
    ChampFinancement["ApportCoProducteur"] = "apportCoProducteur";
    ChampFinancement["ApportEditeurDeMusique"] = "apportEditeurDeMusique";
    ChampFinancement["IndemnisationChomageSalaireArtiste"] = "indemnisationChomageSalaireArtiste";
    ChampFinancement["IndemnisationChomageAutreSalaire"] = "indemnisationChomageAutreSalaire";
    ChampFinancement["RecetteBilletterie"] = "recetteBilletterie";
    ChampFinancement["RecetteVentes"] = "recetteVentes";
    ChampFinancement["RecettesAnnexesCNM"] = "recettesAnnexesCNM";
    ChampFinancement["ONDA"] = "onda";
    ChampFinancement["MecenatAffecte"] = "mecenatAffecte";
    ChampFinancement["FinancementPublicAffecte"] = "financementPublicAffecte";
    ChampFinancement["AutresApportsFinanciersFleches"] = "autresApportsFinanciersFleches";
    ChampFinancement["ApportsStructuresFP"] = "apportsStructuresFP";
})(ChampFinancement || (ChampFinancement = {}));
export var Civilite;
(function (Civilite) {
    Civilite["None"] = "none";
    Civilite["Monsieur"] = "monsieur";
    Civilite["Madame"] = "madame";
})(Civilite || (Civilite = {}));
export var CommissionTimeSlot;
(function (CommissionTimeSlot) {
    CommissionTimeSlot["None"] = "none";
    CommissionTimeSlot["Matin"] = "matin";
    CommissionTimeSlot["ApresMidi"] = "apresMidi";
})(CommissionTimeSlot || (CommissionTimeSlot = {}));
export var ConditionOperator;
(function (ConditionOperator) {
    ConditionOperator["Empty"] = "empty";
    ConditionOperator["Equal"] = "equal";
    ConditionOperator["AnyOf"] = "anyOf";
    ConditionOperator["LesserThan"] = "lesserThan";
})(ConditionOperator || (ConditionOperator = {}));
export var CritereDossierSortProperty;
(function (CritereDossierSortProperty) {
    CritereDossierSortProperty["Categorie"] = "categorie";
    CritereDossierSortProperty["DateDebut"] = "dateDebut";
})(CritereDossierSortProperty || (CritereDossierSortProperty = {}));
export var CritereDossierVersion;
(function (CritereDossierVersion) {
    CritereDossierVersion["All"] = "all";
    CritereDossierVersion["Current"] = "current";
    CritereDossierVersion["Past"] = "past";
    CritereDossierVersion["Future"] = "future";
})(CritereDossierVersion || (CritereDossierVersion = {}));
export var DocumentScope;
(function (DocumentScope) {
    DocumentScope["None"] = "none";
    DocumentScope["Structure"] = "structure";
    DocumentScope["Dossier"] = "dossier";
    DocumentScope["Commission"] = "commission";
})(DocumentScope || (DocumentScope = {}));
export var Emploi;
(function (Emploi) {
    Emploi["None"] = "none";
    Emploi["Musicien"] = "musicien";
    Emploi["Chanteur"] = "chanteur";
    Emploi["ChefOrchestre"] = "chefOrchestre";
    Emploi["Choriste"] = "choriste";
    Emploi["Comedien"] = "comedien";
    Emploi["Circassien"] = "circassien";
    Emploi["Danseur"] = "danseur";
    Emploi["Marionnettiste"] = "marionnettiste";
})(Emploi || (Emploi = {}));
export var Equipements;
(function (Equipements) {
    Equipements["None"] = "none";
    Equipements["PcBureau"] = "pcBureau";
    Equipements["PcPortable"] = "pcPortable";
    Equipements["Tablette"] = "tablette";
    Equipements["Imprimante"] = "imprimante";
    Equipements["TelephonePortable"] = "telephonePortable";
    Equipements["Autre"] = "autre";
})(Equipements || (Equipements = {}));
export var FilterOperator;
(function (FilterOperator) {
    FilterOperator["Equals"] = "equals";
    FilterOperator["NotEquals"] = "notEquals";
    FilterOperator["GreaterThan"] = "greaterThan";
    FilterOperator["LessThan"] = "lessThan";
    FilterOperator["GreaterThanOrEqualTo"] = "greaterThanOrEqualTo";
    FilterOperator["LessThanOrEqualTo"] = "lessThanOrEqualTo";
    FilterOperator["Contains"] = "contains";
    FilterOperator["StartsWith"] = "startsWith";
})(FilterOperator || (FilterOperator = {}));
export var GenerationsSpedidamSortProperty;
(function (GenerationsSpedidamSortProperty) {
    GenerationsSpedidamSortProperty["Commission"] = "commission";
    GenerationsSpedidamSortProperty["StyleMusical"] = "styleMusical";
    GenerationsSpedidamSortProperty["Nom"] = "nom";
    GenerationsSpedidamSortProperty["Prenom"] = "prenom";
    GenerationsSpedidamSortProperty["IsActive"] = "isActive";
    GenerationsSpedidamSortProperty["MontantEnveloppe"] = "montantEnveloppe";
})(GenerationsSpedidamSortProperty || (GenerationsSpedidamSortProperty = {}));
export var GroupeCommission;
(function (GroupeCommission) {
    GroupeCommission["None"] = "none";
    GroupeCommission["A"] = "a";
    GroupeCommission["B"] = "b";
    GroupeCommission["C"] = "c";
    GroupeCommission["Suppleant"] = "suppleant";
})(GroupeCommission || (GroupeCommission = {}));
export var ModeVersement;
(function (ModeVersement) {
    ModeVersement["None"] = "none";
    ModeVersement["Automatique"] = "automatique";
    ModeVersement["Manuel"] = "manuel";
    ModeVersement["Programme"] = "programme";
})(ModeVersement || (ModeVersement = {}));
export var ObjetDiscussion;
(function (ObjetDiscussion) {
    ObjetDiscussion["None"] = "none";
    ObjetDiscussion["InformationGeneral"] = "informationGeneral";
    ObjetDiscussion["MiseAJourCompte"] = "miseAJourCompte";
    ObjetDiscussion["AbsenceLogo"] = "absenceLogo";
    ObjetDiscussion["ConventionNonConforme"] = "conventionNonConforme";
    ObjetDiscussion["ConventionRecueHorodate"] = "conventionRecueHorodate";
    ObjetDiscussion["ContratNonConforme"] = "contratNonConforme";
    ObjetDiscussion["DecisionDefavorable"] = "decisionDefavorable";
    ObjetDiscussion["DecisionFavorable"] = "decisionFavorable";
    ObjetDiscussion["DemandeVersementNonConforme"] = "demandeVersementNonConforme";
    ObjetDiscussion["DemandeVersementAcompteNonConforme"] = "demandeVersementAcompteNonConforme";
    ObjetDiscussion["DemandeVersementSoldeNonConforme"] = "demandeVersementSoldeNonConforme";
    ObjetDiscussion["DemandeVersementAFaire"] = "demandeVersementAFaire";
    ObjetDiscussion["DossierHorsCrit\u00E8res"] = "dossierHorsCrit\u00E8res";
    ObjetDiscussion["DossierIncomplet"] = "dossierIncomplet";
    ObjetDiscussion["EnAttenteConventionSigne"] = "enAttenteConventionSigne";
    ObjetDiscussion["EnAttenteDelegationSignature"] = "enAttenteDelegationSignature";
    ObjetDiscussion["EnAttenteDemandeDerogation"] = "enAttenteDemandeDerogation";
    ObjetDiscussion["EnAttenteSupportPhysique"] = "enAttenteSupportPhysique";
    ObjetDiscussion["EnAttenteValidationServiceJuridique"] = "enAttenteValidationServiceJuridique";
    ObjetDiscussion["EnAttenteValidationServiceSpectacleVivant"] = "enAttenteValidationServiceSpectacleVivant";
    ObjetDiscussion["ExamenDossierReporte"] = "examenDossierReporte";
    ObjetDiscussion["FeuillePresenceNonConforme"] = "feuillePresenceNonConforme";
    ObjetDiscussion["ImpossibleOuvrirPieceJointe"] = "impossibleOuvrirPieceJointe";
    ObjetDiscussion["LienIndiqueNonValide"] = "lienIndiqueNonValide";
    ObjetDiscussion["RemunerationArtisteNonConforme"] = "remunerationArtisteNonConforme";
    ObjetDiscussion["MiseAJourPiecesJointesMonCompte"] = "miseAJourPiecesJointesMonCompte";
    ObjetDiscussion["NonRespectCriteres"] = "nonRespectCriteres";
    ObjetDiscussion["ReaffectationAide"] = "reaffectationAide";
    ObjetDiscussion["UrgentRappelAvantReaffectationAide"] = "urgentRappelAvantReaffectationAide";
    ObjetDiscussion["VersementProrata"] = "versementProrata";
    ObjetDiscussion["VersementAide"] = "versementAide";
    ObjetDiscussion["DemandeRemboursement"] = "demandeRemboursement";
    ObjetDiscussion["DemandeDeComplementInformation"] = "demandeDeComplementInformation";
})(ObjetDiscussion || (ObjetDiscussion = {}));
export var QualificationEnseignant;
(function (QualificationEnseignant) {
    QualificationEnseignant["None"] = "none";
    QualificationEnseignant["Autodidacte"] = "autodidacte";
    QualificationEnseignant["CertificatAptitude"] = "certificatAptitude";
    QualificationEnseignant["DiplomeEtat"] = "diplomeEtat";
    QualificationEnseignant["Autre"] = "autre";
})(QualificationEnseignant || (QualificationEnseignant = {}));
export var RemunerationSortProperty;
(function (RemunerationSortProperty) {
    RemunerationSortProperty["Emploi"] = "emploi";
    RemunerationSortProperty["TypePrestation"] = "typePrestation";
    RemunerationSortProperty["StyleMusical"] = "styleMusical";
    RemunerationSortProperty["CategorieDossier"] = "categorieDossier";
    RemunerationSortProperty["MontantMinimum"] = "montantMinimum";
})(RemunerationSortProperty || (RemunerationSortProperty = {}));
export var Role;
(function (Role) {
    Role["None"] = "none";
    Role["Admin"] = "admin";
    Role["Gerant"] = "gerant";
    Role["ResponsableService"] = "responsableService";
    Role["ResponsableCommissions"] = "responsableCommissions";
    Role["ChargeInstructionDivisionCulturelle"] = "chargeInstructionDivisionCulturelle";
    Role["ChargeInstructionSpectacleVivant"] = "chargeInstructionSpectacleVivant";
    Role["StagiaireDivisionCulturelle"] = "stagiaireDivisionCulturelle";
    Role["MembreCommission"] = "membreCommission";
    Role["ResponsableJuridique"] = "responsableJuridique";
    Role["ResponsableCommunication"] = "responsableCommunication";
    Role["CommissaireComptes"] = "commissaireComptes";
    Role["ResponsableComptable"] = "responsableComptable";
})(Role || (Role = {}));
export var SortDirection;
(function (SortDirection) {
    SortDirection["Asc"] = "asc";
    SortDirection["Desc"] = "desc";
})(SortDirection || (SortDirection = {}));
export var StatutBordereau;
(function (StatutBordereau) {
    StatutBordereau["None"] = "none";
    StatutBordereau["Preparatoire"] = "preparatoire";
    StatutBordereau["Amendable"] = "amendable";
    StatutBordereau["Verse"] = "verse";
})(StatutBordereau || (StatutBordereau = {}));
export var StatutCommission;
(function (StatutCommission) {
    StatutCommission["None"] = "none";
    StatutCommission["Planifiee"] = "planifiee";
    StatutCommission["Figee"] = "figee";
    StatutCommission["EnCours"] = "enCours";
    StatutCommission["EnAttenteCA"] = "enAttenteCA";
    StatutCommission["CaEnCours"] = "caEnCours";
    StatutCommission["Terminee"] = "terminee";
})(StatutCommission || (StatutCommission = {}));
export var StatutDiscussion;
(function (StatutDiscussion) {
    StatutDiscussion["None"] = "none";
    StatutDiscussion["EnCours"] = "enCours";
    StatutDiscussion["Termine"] = "termine";
})(StatutDiscussion || (StatutDiscussion = {}));
export var StatutDossier;
(function (StatutDossier) {
    StatutDossier["None"] = "none";
    StatutDossier["Brouillon"] = "brouillon";
    StatutDossier["SansSuite"] = "sansSuite";
    StatutDossier["Soumis"] = "soumis";
    StatutDossier["PrisEnCharge"] = "prisEnCharge";
    StatutDossier["HorsCriteres"] = "horsCriteres";
    StatutDossier["Renonciation"] = "renonciation";
    StatutDossier["ProgrammeEnCommission"] = "programmeEnCommission";
    StatutDossier["Refuse"] = "refuse";
    StatutDossier["Accepte"] = "accepte";
    StatutDossier["Solde"] = "solde";
    StatutDossier["Reaffecte"] = "reaffecte";
})(StatutDossier || (StatutDossier = {}));
export var StatutEnseignant;
(function (StatutEnseignant) {
    StatutEnseignant["None"] = "none";
    StatutEnseignant["Permanent"] = "permanent";
    StatutEnseignant["Vacataire"] = "vacataire";
})(StatutEnseignant || (StatutEnseignant = {}));
export var StatutGenerationPdf;
(function (StatutGenerationPdf) {
    StatutGenerationPdf["None"] = "none";
    StatutGenerationPdf["Pending"] = "pending";
    StatutGenerationPdf["Done"] = "done";
    StatutGenerationPdf["Failed"] = "failed";
})(StatutGenerationPdf || (StatutGenerationPdf = {}));
export var StatutPageVitrine;
(function (StatutPageVitrine) {
    StatutPageVitrine["None"] = "none";
    StatutPageVitrine["Draft"] = "draft";
    StatutPageVitrine["Published"] = "published";
})(StatutPageVitrine || (StatutPageVitrine = {}));
export var StatutStructure;
(function (StatutStructure) {
    StatutStructure["None"] = "none";
    StatutStructure["Pending"] = "pending";
    StatutStructure["Enabled"] = "enabled";
    StatutStructure["Disabled"] = "disabled";
    StatutStructure["Partial"] = "partial";
})(StatutStructure || (StatutStructure = {}));
export var StatutVersement;
(function (StatutVersement) {
    StatutVersement["None"] = "none";
    StatutVersement["Brouillon"] = "brouillon";
    StatutVersement["Soumis"] = "soumis";
    StatutVersement["Modification"] = "modification";
    StatutVersement["Valide"] = "valide";
    StatutVersement["Verse"] = "verse";
    StatutVersement["PriseEnCharge"] = "priseEnCharge";
    StatutVersement["EnAttente"] = "enAttente";
    StatutVersement["Reaffectation"] = "reaffectation";
})(StatutVersement || (StatutVersement = {}));
export var TypeBordereau;
(function (TypeBordereau) {
    TypeBordereau["None"] = "none";
    TypeBordereau["Versement"] = "versement";
    TypeBordereau["Reaffectation"] = "reaffectation";
})(TypeBordereau || (TypeBordereau = {}));
export var TypeContrat;
(function (TypeContrat) {
    TypeContrat["None"] = "none";
    TypeContrat["Cdi"] = "cdi";
    TypeContrat["Cdd"] = "cdd";
    TypeContrat["Cdii"] = "cdii";
    TypeContrat["Autre"] = "autre";
})(TypeContrat || (TypeContrat = {}));
export var TypeDeDocumentExtraInfoValueType;
(function (TypeDeDocumentExtraInfoValueType) {
    TypeDeDocumentExtraInfoValueType["String"] = "string";
    TypeDeDocumentExtraInfoValueType["Date"] = "date";
})(TypeDeDocumentExtraInfoValueType || (TypeDeDocumentExtraInfoValueType = {}));
export var TypeDepense;
(function (TypeDepense) {
    TypeDepense["None"] = "none";
    TypeDepense["Autre"] = "autre";
    TypeDepense["BudgetPrevisionnelDepenses"] = "budgetPrevisionnelDepenses";
    TypeDepense["SalaireAutrePersonnel"] = "salaireAutrePersonnel";
    TypeDepense["AutresDepenses"] = "autresDepenses";
    TypeDepense["BudgetRepetitionsEtEnregistrements"] = "budgetRepetitionsEtEnregistrements";
    TypeDepense["BudgetScenique"] = "budgetScenique";
    TypeDepense["Promotion"] = "promotion";
    TypeDepense["Salles"] = "salles";
    TypeDepense["FraisDeplacement"] = "fraisDeplacement";
    TypeDepense["ContratsVenteEtAutreSalairePersonnel"] = "contratsVenteEtAutreSalairePersonnel";
    TypeDepense["AutreMasseSalariale"] = "autreMasseSalariale";
    TypeDepense["FraisDePersonnel"] = "fraisDePersonnel";
    TypeDepense["AutresFraisDePersonnel"] = "autresFraisDePersonnel";
    TypeDepense["ServicesExterieurs"] = "servicesExterieurs";
    TypeDepense["ImpotsTaxes"] = "impotsTaxes";
    TypeDepense["FraisDeRealisationDuDocumentDePromotion"] = "fraisDeRealisationDuDocumentDePromotion";
    TypeDepense["Droits"] = "droits";
    TypeDepense["BudgetPrevisionnelAnnulations"] = "budgetPrevisionnelAnnulations";
    TypeDepense["BaseCalculAide"] = "baseCalculAide";
    TypeDepense["AutresCharges"] = "autresCharges";
})(TypeDepense || (TypeDepense = {}));
export var TypeFinancement;
(function (TypeFinancement) {
    TypeFinancement["None"] = "none";
    TypeFinancement["Autre"] = "autre";
    TypeFinancement["RecettesPropres"] = "recettesPropres";
    TypeFinancement["Recettes"] = "recettes";
    TypeFinancement["FinancementPublic"] = "financementPublic";
    TypeFinancement["SubventionsOrganismesProfessionnels"] = "subventionsOrganismesProfessionnels";
    TypeFinancement["SubventionsEtatCollectivitesTerritoriales"] = "subventionsEtatCollectivitesTerritoriales";
})(TypeFinancement || (TypeFinancement = {}));
export var TypePoste;
(function (TypePoste) {
    TypePoste["None"] = "none";
    TypePoste["Administrateur"] = "administrateur";
    TypePoste["Tresorier"] = "tresorier";
    TypePoste["SecretaireAdministratif"] = "secretaireAdministratif";
    TypePoste["Directeur"] = "directeur";
    TypePoste["President"] = "president";
    TypePoste["Gerant"] = "gerant";
})(TypePoste || (TypePoste = {}));
export var TypePrestation;
(function (TypePrestation) {
    TypePrestation["None"] = "none";
    TypePrestation["Repetition"] = "repetition";
    TypePrestation["Enregistrement"] = "enregistrement";
    TypePrestation["Representation"] = "representation";
    TypePrestation["Diffusion"] = "diffusion";
    TypePrestation["Concert"] = "concert";
})(TypePrestation || (TypePrestation = {}));
export var TypesAdresses;
(function (TypesAdresses) {
    TypesAdresses["None"] = "none";
    TypesAdresses["AdresseSiege"] = "adresseSiege";
    TypesAdresses["AdressePersonnelle"] = "adressePersonnelle";
    TypesAdresses["Autre"] = "autre";
})(TypesAdresses || (TypesAdresses = {}));
export var TypeTransport;
(function (TypeTransport) {
    TypeTransport["None"] = "none";
    TypeTransport["Voiture"] = "voiture";
    TypeTransport["Train"] = "train";
    TypeTransport["Avion"] = "avion";
})(TypeTransport || (TypeTransport = {}));
export var TypeVersement;
(function (TypeVersement) {
    TypeVersement["None"] = "none";
    TypeVersement["Acompte"] = "acompte";
    TypeVersement["Solde"] = "solde";
    TypeVersement["Complet"] = "complet";
    TypeVersement["Complementaire"] = "complementaire";
})(TypeVersement || (TypeVersement = {}));
export var VueType;
(function (VueType) {
    VueType["None"] = "none";
    VueType["Structure"] = "structure";
    VueType["Dossier"] = "dossier";
})(VueType || (VueType = {}));
export var ProblemDetailsCode;
(function (ProblemDetailsCode) {
    ProblemDetailsCode["Unknown"] = "unknown";
    ProblemDetailsCode["InvalidParameters"] = "invalidParameters";
    ProblemDetailsCode["PreconditionFailed"] = "preconditionFailed";
    ProblemDetailsCode["AccessDenied"] = "accessDenied";
    ProblemDetailsCode["Unauthorized"] = "unauthorized";
    ProblemDetailsCode["Forbidden"] = "forbidden";
    ProblemDetailsCode["EntityNotFound"] = "entityNotFound";
    ProblemDetailsCode["EmailingServiceUnavailable"] = "emailingServiceUnavailable";
    ProblemDetailsCode["SiretNotFound"] = "siretNotFound";
    ProblemDetailsCode["MissingDocument"] = "missingDocument";
    ProblemDetailsCode["MissingDocumentExtraInfo"] = "missingDocumentExtraInfo";
    ProblemDetailsCode["InvalidDocument"] = "invalidDocument";
    ProblemDetailsCode["InvalidDocumentExtraInfoValue"] = "invalidDocumentExtraInfoValue";
    ProblemDetailsCode["DocumentExpired"] = "documentExpired";
    ProblemDetailsCode["InvalidLanguage"] = "invalidLanguage";
    ProblemDetailsCode["CannotResetStatutStructure"] = "cannotResetStatutStructure";
    ProblemDetailsCode["CannotModifyActiveCritereDossier"] = "cannotModifyActiveCritereDossier";
    ProblemDetailsCode["CannotDeleteNonEmptyCategory"] = "cannotDeleteNonEmptyCategory";
    ProblemDetailsCode["EntityAlreadyExists"] = "entityAlreadyExists";
    ProblemDetailsCode["EntitiesNotFound"] = "entitiesNotFound";
    ProblemDetailsCode["StructurePending"] = "structurePending";
    ProblemDetailsCode["StructureDisabled"] = "structureDisabled";
    ProblemDetailsCode["InvalidPrestation"] = "invalidPrestation";
    ProblemDetailsCode["CategorieDossierQuotaExceeded"] = "categorieDossierQuotaExceeded";
    ProblemDetailsCode["ForbiddenCategorieDossier"] = "forbiddenCategorieDossier";
    ProblemDetailsCode["NotImplemented"] = "notImplemented";
    ProblemDetailsCode["BudgetNotBalanced"] = "budgetNotBalanced";
    ProblemDetailsCode["MontantAideMustBeInferior"] = "montantAideMustBeInferior";
    ProblemDetailsCode["MontantAideMustBeSuperior"] = "montantAideMustBeSuperior";
    ProblemDetailsCode["MontantAideMustBeInferiorOrEqual"] = "montantAideMustBeInferiorOrEqual";
    ProblemDetailsCode["MontantDepenseMustBeInferior"] = "montantDepenseMustBeInferior";
    ProblemDetailsCode["MontantDepenseMustBeSuperiorOrEqualException"] = "montantDepenseMustBeSuperiorOrEqualException";
    ProblemDetailsCode["MontantFinancementMustBeInferior"] = "montantFinancementMustBeInferior";
    ProblemDetailsCode["MontantFinancementMustBeSuperiorOrEqual"] = "montantFinancementMustBeSuperiorOrEqual";
    ProblemDetailsCode["InvalidAnswers"] = "invalidAnswers";
    ProblemDetailsCode["AdresseNotFound"] = "adresseNotFound";
    ProblemDetailsCode["MissingFile"] = "missingFile";
    ProblemDetailsCode["InvalidIban"] = "invalidIban";
    ProblemDetailsCode["MinimumRemuneration"] = "minimumRemuneration";
    ProblemDetailsCode["InvalidStatutDossierChange"] = "invalidStatutDossierChange";
    ProblemDetailsCode["CannotUpdateDossier"] = "cannotUpdateDossier";
    ProblemDetailsCode["CannotDeleteDossier"] = "cannotDeleteDossier";
    ProblemDetailsCode["CannotDeleteVersement"] = "cannotDeleteVersement";
    ProblemDetailsCode["MaximumDates"] = "maximumDates";
    ProblemDetailsCode["MaxRangeBetweenDatesExceeded"] = "maxRangeBetweenDatesExceeded";
    ProblemDetailsCode["DateCAMustBeSuperiorToDateDebutCommission"] = "dateCAMustBeSuperiorToDateDebutCommission";
    ProblemDetailsCode["DateFinMustBeSuperiorToDateDebutCommission"] = "dateFinMustBeSuperiorToDateDebutCommission";
    ProblemDetailsCode["DateFinSoumissionMustBeInferiorToDateDebutCommission"] = "dateFinSoumissionMustBeInferiorToDateDebutCommission";
    ProblemDetailsCode["DateDebutDossierMustBeSuperiorToDateFinCommission"] = "dateDebutDossierMustBeSuperiorToDateFinCommission";
    ProblemDetailsCode["CommissionWithSameDateDebutExistsException"] = "commissionWithSameDateDebutExistsException";
    ProblemDetailsCode["CannotUpdateCommissionWithDossiersException"] = "cannotUpdateCommissionWithDossiersException";
    ProblemDetailsCode["EmailAlreadyUsed"] = "emailAlreadyUsed";
    ProblemDetailsCode["InvalidStatutCommission"] = "invalidStatutCommission";
    ProblemDetailsCode["InvalidStatutDossierToChangeCommission"] = "invalidStatutDossierToChangeCommission";
    ProblemDetailsCode["CannotUpdateCommissionStatut"] = "cannotUpdateCommissionStatut";
    ProblemDetailsCode["CannotOpenCommission"] = "cannotOpenCommission";
    ProblemDetailsCode["CannotPrendreEnchargeDossier"] = "cannotPrendreEnchargeDossier";
    ProblemDetailsCode["CannotPrendreEnchargeDemandeVersement"] = "cannotPrendreEnchargeDemandeVersement";
    ProblemDetailsCode["DossiersNonValideEnCommission"] = "dossiersNonValideEnCommission";
    ProblemDetailsCode["CommissionsMembersAreNotSet"] = "commissionsMembersAreNotSet";
    ProblemDetailsCode["DateFinSoumissionMustBePassed"] = "dateFinSoumissionMustBePassed";
    ProblemDetailsCode["MinCachetRequired"] = "minCachetRequired";
    ProblemDetailsCode["PeriodStartDateShouldBeAfterCommissionEnding"] = "periodStartDateShouldBeAfterCommissionEnding";
    ProblemDetailsCode["DateEmbaucheIsNotValid"] = "dateEmbaucheIsNotValid";
    ProblemDetailsCode["DossierIsNotValid"] = "dossierIsNotValid";
    ProblemDetailsCode["CannotRenounceDossier"] = "cannotRenounceDossier";
    ProblemDetailsCode["InvalidBordereauStatus"] = "invalidBordereauStatus";
    ProblemDetailsCode["BordereauAmendableMaxExceeded"] = "bordereauAmendableMaxExceeded";
    ProblemDetailsCode["CannotCloseBordereau"] = "cannotCloseBordereau";
    ProblemDetailsCode["CannotArchiveBordereau"] = "cannotArchiveBordereau";
    ProblemDetailsCode["InvalidOperation"] = "invalidOperation";
    ProblemDetailsCode["CannotDeleteMouvementBordereauVerse"] = "cannotDeleteMouvementBordereauVerse";
    ProblemDetailsCode["CannotDeleteMouvementBordereau"] = "cannotDeleteMouvementBordereau";
    ProblemDetailsCode["BordereauStillAmendable"] = "bordereauStillAmendable";
    ProblemDetailsCode["BordereauReaffectationStillAmendable"] = "bordereauReaffectationStillAmendable";
    ProblemDetailsCode["CannotFigerCommissionWithOutstandingDossiers"] = "cannotFigerCommissionWithOutstandingDossiers";
    ProblemDetailsCode["CannotProgrammerEnCommissionDossierCommissionClosed"] = "cannotProgrammerEnCommissionDossierCommissionClosed";
    ProblemDetailsCode["CannotProgrammerEnCommissionDossierCACommissionClosed"] = "cannotProgrammerEnCommissionDossierCACommissionClosed";
    ProblemDetailsCode["CannotUpdateCommissionContent"] = "cannotUpdateCommissionContent";
    ProblemDetailsCode["CannotUpdateCommissionCAContent"] = "cannotUpdateCommissionCAContent";
    ProblemDetailsCode["CannotCreateCritereDossierOnCommissionSpecifique"] = "cannotCreateCritereDossierOnCommissionSpecifique";
    ProblemDetailsCode["InvalidDate"] = "invalidDate";
})(ProblemDetailsCode || (ProblemDetailsCode = {}));
export class ApiException extends Error {
    constructor(message, status, response, headers, result) {
        super();
        this.isApiException = true;
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    static isApiException(obj) {
        return obj.isApiException === true;
    }
}
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
function isAxiosError(obj) {
    return obj && obj.isAxiosError === true;
}
